/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, {
  FC,
  useCallback,
  useEffect,
  useState
} from 'react'
import { useNavigate } from 'react-router-dom'
import { produce } from 'immer'
import { Button } from '@progress/kendo-react-buttons'
import { StackLayout, CardActions } from '@progress/kendo-react-layout'

import { Contents } from '../../../components/layouts'
import { BuildingInformationCard } from './BuildingInformationCard'
import { ExpenseInformation } from './ExpenseInformation'
import {
  ManualSimulationSheet,
  GridElement,
  CellValue
} from './ManualSimulationSheet'
import { DispatchAllotmentSheet } from './DispatchAllotmentSheet'
import { ConfirmDialog, ErrorMessage, ErrorMessages } from '../../../components/parts'
import {
  CommonActions,
  SimulationBuildingSearchActions,
  useAppDispatch,
  useAppSelector
} from '../../../stores'
import {
  ManualYamadumiItem,
  ManualYamadumiNewItem,
  SupplierAllocationNewItem,
  SimulationCalculationInfoResItem,
  PutManualSimulationAllotment,
  SimulationYamadumiAutoItem,
  SimulationBuildingBuildingInfo,
  GetSimulationSupplierAllocationReq,
  AllocationSupplier,
  DataWorkQuantitySheetItem
} from '@gateway.Simulation'
import {
  _initM2DataSheetList,
  sumBottompManualYamadumiList,
  _initDataWorkQuantityTypeObj,
  putManualSimulationAllotmentData
} from './_InitManualSimulationAllotment_Data'
import { GetSupplierAllocationGateway } from '../../../gateway/simulation/GetSupplierAllocationGateway'
import { SimulationYamadumiGateway } from '../../../gateway/simulation/SimulationYamadumiGateway'
import { YamadumiAutoGateway } from '../../../gateway/simulation/YamadumiAutoGateway'
import { YamadumiManualGateway } from '../../../gateway/simulation/YamadumiManualGateway'
import { WorkYamadumiCalculationInfoGateway } from '../../../gateway/simulation/WorkYamadumiCalculationInfoGateway'
import { BuildingItemGateway } from '../../../gateway/simulation/BuildingItemGateway'
import ReactDataSheet from 'react-datasheet'
import { MessageProvider } from '../../../services/resources/MessageProvider'
import { useAccessibleAuthority, usePageTitle } from '../../../components/hooks'
import { Authority } from '../../../gateway/system/Authority'
import { SearchSupplierGateway } from '../../../gateway/supplier/SearchSupplierGateway'
import simulationMessage from '../../../data/simulation-message.json'
import { YamadumiAutoPriorityGateway } from '../../../gateway/simulation/YamadumiAutoPriorityGateway'

/**
 * 少数を整数に切り上げる
 */
const exactNumberDigits = (num: number) => {
  return Math.ceil(num)
}
/**
 * 少数を整数に四捨五入する
 */
const exactNumberRound = (num: number) => {
  return Math.round(num)
}
/**
 * 費目エリアの計算
 */
const creatWholeResult = (
  type: string,
  schedule: number,
  totalFloorAreaM2: number,
  totalFloorAreaTsubo: number,
  workYamadumiInfo?: SimulationCalculationInfoResItem,
  calcFlg: boolean = false // 項目計算時に変更対象の値を使用する場合はtrue
) => {
  if (workYamadumiInfo === undefined) {
    return
  }

  // A
  /**
   * 施工数量-基礎
   */
  const getConstructionQuantityFoundationA = () => {
    return (Number(totalFloorAreaM2) * Number(workYamadumiInfo.structureRatioFoundation))
  }

  /**
   * 施工数量-地下
   */
  const getConstructionQuantityUndergroundA = () => {
    return (Number(totalFloorAreaM2) * Number(workYamadumiInfo.structureRatioUnderground))
  }

  /**
   * 施工数量-地上
   */
  const getConstructionQuantityGroundA = () => {
    return (Number(totalFloorAreaM2) * Number(workYamadumiInfo.structureRatioGround))
  }

  /**
   * 施工数量 全体
   * 全体予定労務数/数量 A
   * 画面．施工数量（全体） = 画面．施工数量（基礎） + 画面．施工数量（地下） + 画面．施工数量（先行床） + 画面．施工数量（地上）
   */
  const getWholeResultA = () => {
    return (calcFlg
      ? (
          // 施工数量を手入力していた場合は、その値で合計値を算出する
          Number(workYamadumiInfo.constructionQuantityFoundation) +
          Number(workYamadumiInfo.constructionQuantityUnderground) +
          Number(workYamadumiInfo.constructionQuantityFloorPrecedence) +
          Number(workYamadumiInfo.constructionQuantityGround)
        )
      : (getConstructionQuantityFoundationA() + getConstructionQuantityUndergroundA() + Number(workYamadumiInfo.constructionQuantityFloorPrecedence) + getConstructionQuantityGroundA()))
  }

  /**
   * 予定労務数/数量-基礎 A
   * 予定労務数/数量-基礎 = 変数．費目情報．施工数量-基礎 / 変数．費目情報．歩掛-基礎 / 変数．費目情報．工期-基礎 / 変数．費目情報．1ヶ月稼働日数
   */
  const getScheduledWorkFoundationA = () => {
    return ((Number(workYamadumiInfo.productionRateFoundation) === 0 || Number(workYamadumiInfo.scheduleFoundation) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
      ? 0
      : calcFlg
        ? (
      // 施工数量を手入力していた場合は、その値で合計値を算出する
            exactNumberRound(Number(workYamadumiInfo.constructionQuantityFoundation) /
        Number(workYamadumiInfo.productionRateFoundation) /
        Number(workYamadumiInfo.monthWorkday)) /
        Number(workYamadumiInfo.scheduleFoundation))
        : (
            exactNumberRound(getConstructionQuantityFoundationA() /
        Number(workYamadumiInfo.productionRateFoundation) /
        Number(workYamadumiInfo.monthWorkday)) /
        Number(workYamadumiInfo.scheduleFoundation))
    )
  }

  /**
   * 予定労務数/数量-地下 A
   * 予定労務数/数量-地下 = 変数．費目情報．施工数量-地下 / 変数．費目情報．歩掛-地下 / 変数．費目情報．工期-地下 / 変数．費目情報．1ヶ月稼働日数
   */
  const getScheduledWorkUndergroundA = () => {
    return ((Number(workYamadumiInfo.productionRateUnderground) === 0 || Number(workYamadumiInfo.scheduleUnderground) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
      ? 0
      : calcFlg
        ? (
      // 施工数量を手入力していた場合は、その値で合計値を算出する
            exactNumberRound(Number(workYamadumiInfo.constructionQuantityUnderground) /
        Number(workYamadumiInfo.productionRateUnderground) /
        Number(workYamadumiInfo.monthWorkday)) /
        Number(workYamadumiInfo.scheduleUnderground))
        : (
            exactNumberRound(getConstructionQuantityUndergroundA() /
        Number(workYamadumiInfo.productionRateUnderground) /
        Number(workYamadumiInfo.monthWorkday)) /
        Number(workYamadumiInfo.scheduleUnderground))
    )
  }

  /**
   * 予定労務数/数量-先行床 A
   * 予定労務数/数量-先行床 = 変数．費目情報．施工数量-先行床 / 変数．費目情報．歩掛-先行床 / 変数．費目情報．工期-先行床 / 変数．費目情報．1ヶ月稼働日数
   */
  const getScheduledWorkFloorPrecedenceA = () => {
    return ((Number(workYamadumiInfo.productionRateFloorPrecedence) === 0 || Number(workYamadumiInfo.scheduleFloorPrecedence) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
      ? 0
      : (exactNumberRound(Number(workYamadumiInfo.constructionQuantityFloorPrecedence) /
      Number(workYamadumiInfo.productionRateFloorPrecedence) /
      Number(workYamadumiInfo.monthWorkday)) /
      Number(workYamadumiInfo.scheduleFloorPrecedence))
    )
  }

  /**
   * 予定労務数/数量-地上 A
   * 予定労務数/数量-地上 = 変数．費目情報．施工数量-地上 / 変数．費目情報．歩掛-地上 / 変数．費目情報．工期-地上 / 変数．費目情報．1ヶ月稼働日数
   */
  const getScheduledWorkGroundA = () => {
    return ((Number(workYamadumiInfo.productionRateGround) === 0 || Number(workYamadumiInfo.scheduleGround) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
      ? 0
      : calcFlg
        ? (
      // 施工数量を手入力していた場合は、その値で合計値を算出する
            exactNumberRound(Number(workYamadumiInfo.constructionQuantityGround) /
        Number(workYamadumiInfo.productionRateGround) /
        Number(workYamadumiInfo.monthWorkday)) /
        Number(workYamadumiInfo.scheduleGround))
        : (
            exactNumberRound(getConstructionQuantityGroundA() /
        Number(workYamadumiInfo.productionRateGround) /
        Number(workYamadumiInfo.monthWorkday)) /
        Number(workYamadumiInfo.scheduleGround))
    )
  }

  // B
  /**
   * 全体予定労務数/数量 B
   * 全体予定労務数 = 画面．坪単価 × 画面．坪数 / 画面．労務単価
   */
  const getWholeResultB = () => {
    return (
      Number(workYamadumiInfo.costPerWork) === 0
        ? 0
        : (Number(workYamadumiInfo.costPerTsubo) * totalFloorAreaTsubo) /
      Number(workYamadumiInfo.costPerWork)
    )
  }

  /**
   * 合計予定労務数/数量-準備 B
   */
  const getAllScheduledWorkPreparationB = () => {
    return exactNumberDigits(getWholeResultB() * Number(workYamadumiInfo.workRatioPreparation) / 100)
  }

  /**
   * 合計予定労務数/数量-基礎・地下 B
   * 全体予定労務数/数量-基礎・地下 = 全体予定労務数/数量 × 画面．労務比率-基礎・地下 / 100
   */
  const getAllScheduledWorkFoundationUndergroundB = () => {
    return exactNumberDigits(getWholeResultB() * Number(workYamadumiInfo.workRatioFoundationUnderground) / 100)
  }

  /**
   * 合計予定労務数/数量-地上 B
   * 全体予定労務数/数量-地上 = 変数．全体予定労務数/数量 × 画面．労務比率-地上 / 100
   */
  const getAllScheduledWorkGroundB = () => {
    return exactNumberDigits(getWholeResultB() * Number(workYamadumiInfo.workRatioGround) / 100)
  }

  /**
   * 予定労務数/数量-準備 B
   * 全体予定労務数/数量-準備 = 全体予定労務数/数量 × 画面．労務比率-準備 / 100
   * 予定労務数/数量-準備 = 変数．グループ全体予定労務数/数量-準備(★) / stateBuildingInfo．工期 × 変数．費目情報．工期比率-準備/ 100 / 変数．費目情報．1ヶ月稼働日数
   */
  const getScheduledWorkPreparationB = () => {
    return (
      (exactNumberDigits(schedule * Number(workYamadumiInfo.scheduleRatioPreparation) / 100) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
        ? 0
        : getAllScheduledWorkPreparationB() /
      exactNumberDigits(schedule * Number(workYamadumiInfo.scheduleRatioPreparation) / 100) /
      Number(workYamadumiInfo.monthWorkday)
    )
  }

  /**
   * 予定労務数/数量-基礎・地下 B
   * 全体予定労務数/数量-基礎・地下 = 全体予定労務数/数量 × 画面．労務比率-基礎・地下 / 100
   * 予定労務数/数量-基礎・地下 = 変数．グループ全体予定労務数/数量-基礎・地下(★) / stateBuildingInfo．工期 × 変数．費目情報．工期比率-基礎・地下 / 100 / 変数．費目情報．1ヶ月稼働日数
   */
  const getScheduledWorkUndergroundB = () => {
    return (
      (exactNumberDigits(schedule * Number(workYamadumiInfo.scheduleRatioFoundationUnderground) / 100) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
        ? 0
        : getAllScheduledWorkFoundationUndergroundB() /
      exactNumberDigits(schedule * Number(workYamadumiInfo.scheduleRatioFoundationUnderground) / 100) /
      Number(workYamadumiInfo.monthWorkday)
    )
  }

  /**
   * 予定労務数/数量-地上 B
   * 全体予定労務数/数量-基礎・地上 = 全体予定労務数/数量 × 画面．労務比率-地上 / 100
   * 予定労務数/数量ー地上 = 全体予定労務数/数量-地上 / stateBuildingInfo．工期 × 画面．工期比率-地上 / 100 / stateExpenseInfo．1ヶ月稼働日数
   */
  const getScheduledWorkGroundB = () => {
    return (
      (exactNumberDigits(schedule * Number(workYamadumiInfo.scheduleRatioGround) / 100) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
        ? 0
        : getAllScheduledWorkGroundB() /
      exactNumberDigits(schedule * Number(workYamadumiInfo.scheduleRatioGround) / 100) /
      Number(workYamadumiInfo.monthWorkday)
    )
  }

  /**
   *
   * 予定労務数/数量-仕上げ B
   * グループ全体予定労務数/数量-基礎・地下 = 変数．全体予定労務数/数量 × 画面．労務比率-基礎・地下 / 100
   * グループ全体全体予定労務数/数量-準備 = 全体予定労務数/数量 × 画面．労務比率-準備 / 100
   * グループ全体全体予定労務数/数量-基礎・地下 =  変数．全体予定労務数/数量 × 画面．労務比率-基礎・地下 / 100
   * グループ全体全体予定労務数/数量-仕上げ = 全体予定労務数/数量 -(変数．グループ全体予定労務数/数量-準備 + 変数．グループ全体予定労務数/数量-基礎・地下 + 変数．グループ全体予定労務数/数量-地上)
   * 予定労務数/数量-仕上げ = 変数．グループ全体予定労務数/数量-仕上げ / stateBuildingInfo．工期 × 画面．工期比率-仕上げ / 100 / stateExpenseInfo．1ヶ月稼働日数
   */
  const getScheduledWorkFinishB = () => {
    return (
      (exactNumberDigits(schedule * Number(workYamadumiInfo.scheduleRatioFinish) / 100) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
        ? 0
        : (exactNumberDigits(getWholeResultB()) -
        (Number(getAllScheduledWorkPreparationB()) +
          Number(getAllScheduledWorkFoundationUndergroundB()) +
          Number(getAllScheduledWorkGroundB()))) /
        exactNumberDigits(schedule * Number(workYamadumiInfo.scheduleRatioFinish) / 100) / Number(workYamadumiInfo.monthWorkday)
    )
  }

  // C
  /**
   * 全体予定労務数 C
   * 全体予定労務数 = 画面．費目工事金額 / 画面．労務単価
   */
  const getWholeResultC = () => {
    return Number(workYamadumiInfo.costPerWork) === 0 ? 0 : Number(workYamadumiInfo.expenseCost) / Number(workYamadumiInfo.costPerWork)
  }

  /**
   * 予定労務数/数量-仕上げ C
   * 全体予定労務数 = 全体予定労務数/数量 / stateBuildingInfo．工期 × 変数．費目情報．工期比率-仕上げ/ 100 / stateExpenseInfo．1ヶ月稼働日数
   */
  const getScheduledWorkFinishC = () => {
    return (
      (Number(Number(schedule) * (Number(workYamadumiInfo.scheduleRatioFinish) / 100)) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
        ? 0
        : getWholeResultC() / (Number(schedule) * (Number(workYamadumiInfo.scheduleRatioFinish) / 100)) /
      Number(workYamadumiInfo.monthWorkday)
    )
  }

  /**
   * 予定労務数/数量-その他 C
   * 予定労務数/数量-その他 = 予定労務数/数量-仕上げ / stateExpenseInfo．定数
   */
  const getScheduledWorkOtherC = () => {
    return Number(workYamadumiInfo.constant) === 0
      ? 0
      // 予定労務数-仕上げを手入力で変更した場合は、その入力値を使用して算出する
      : calcFlg
        ? Number(workYamadumiInfo.scheduledWorkFinish) / Number(workYamadumiInfo.constant)
        : exactNumberDigits(getScheduledWorkFinishC()) / Number(workYamadumiInfo.constant)
  }

  // D
  /**
   * 全体予定労務数 D
   * 全体予定労務数 D = 画面．費目工事金額 / 画面．労務単価
   */
  const getWholeResultD = () => {
    return Number(workYamadumiInfo.costPerWork) === 0 ? 0 : Number(workYamadumiInfo.expenseCost) / Number(workYamadumiInfo.costPerWork)
  }

  /**
   * 予定労務数/数量-仕上げ D
   *予定労務数/数量-仕上げ = stateExpenseInfo．全体予定労務数/数量 / stateBuildingInfo．工期 × 変数．費目情報．工期比率-仕上げ / 100 / stateExpenseInfo．1ヶ月稼働日数
   */
  const getScheduledWorkFinishD = () => {
    return (
      (Number(Number(schedule) * (Number(workYamadumiInfo.scheduleRatioFinish) / 100)) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
        ? 0
        : getWholeResultD() / (Number(schedule) * (Number(workYamadumiInfo.scheduleRatioFinish) / 100)) /
      Number(workYamadumiInfo.monthWorkday)
    )
  }

  // E
  /**
   * 費目工事金額
   * 費目工事金額 = 画面.坪単価 × 画面．坪数 × 画面．定数 ※100の倍数に四捨五入する
   */
  const getExpenseCost = () => {
    return (
      exactNumberRound(Number(workYamadumiInfo.costPerTsubo) * totalFloorAreaTsubo * Number(workYamadumiInfo.constant) / 100) * 100
    )
  }
  /**
   * 全体予定労務数 E
   * 全体予定労務数  = 費目工事金額 × 画面．安全率 × 画面．労務比率 / 100 / 労務単価
   */
  const getWholeResultE = () => {
    return (
      Number(workYamadumiInfo.costPerWork) === 0
        ? 0
        : calcFlg
          // 費目工事金額を手入力で変更した場合は、その入力値を使用して算出する
          ? (Number(workYamadumiInfo.expenseCost) *
            Number(workYamadumiInfo.safeRatio) *
            Number(workYamadumiInfo.workRatioFinish)) /
            100 /
            Number(workYamadumiInfo.costPerWork)
          : (getExpenseCost() *
            Number(workYamadumiInfo.safeRatio) *
            Number(workYamadumiInfo.workRatioFinish)) /
            100 /
            Number(workYamadumiInfo.costPerWork)
    )
  }
  /**
   * 予定労務数 E
   * 予定労務数 = 全体予定労務数 / 全体工期 × 工期比率 / 100 （/ 1ヶ月稼働日数）
   */
  const getScheduledWorkE = () => {
    return (
      (exactNumberDigits(Number(schedule) * Number(workYamadumiInfo.scheduleRatioFinish) / 100) === 0 || Number(workYamadumiInfo.monthWorkday) === 0)
        ? 0
        : getWholeResultE() / exactNumberDigits(Number(schedule) * Number(workYamadumiInfo.scheduleRatioFinish) / 100) /
      Number(workYamadumiInfo.monthWorkday)
    )
  }

  if (type === 'A') {
    return {
      wholeResultA: getWholeResultA(),
      constructionQuantityFoundationA: getConstructionQuantityFoundationA(),
      constructionQuantityUndergroundA: getConstructionQuantityUndergroundA(),
      constructionQuantityGroundA: getConstructionQuantityGroundA(),
      scheduledWorkFoundationA: exactNumberDigits(getScheduledWorkFoundationA()),
      scheduledWorkUndergroundA: exactNumberDigits(getScheduledWorkUndergroundA()),
      scheduledWorkFloorPrecedenceA: exactNumberDigits(getScheduledWorkFloorPrecedenceA()),
      scheduledWorkGroundA: exactNumberDigits(getScheduledWorkGroundA())
    }
  }
  if (type === 'B') {
    return {
      wholeResultB: exactNumberDigits(getWholeResultB()),
      scheduledWorkPreparationB: exactNumberDigits(getScheduledWorkPreparationB()),
      scheduledWorkUndergroundB: exactNumberDigits(getScheduledWorkUndergroundB()),
      scheduledWorkGroundB: exactNumberDigits(getScheduledWorkGroundB()),
      scheduledWorkFinishB: exactNumberDigits(getScheduledWorkFinishB())
    }
  }
  if (type === 'C') {
    return {
      wholeResultC: exactNumberRound(getWholeResultC()),
      scheduledWorkFinishC: exactNumberDigits(getScheduledWorkFinishC()),
      scheduledWorkOtherC: exactNumberDigits(getScheduledWorkOtherC())
    }
  }
  if (type === 'D') {
    return {
      wholeResultD: exactNumberRound(getWholeResultD()),
      scheduledWorkFinishD: exactNumberDigits(getScheduledWorkFinishD())
    }
  }
  if (type === 'E') {
    return {
      expenseCostE: getExpenseCost(),
      wholeResultE: exactNumberRound(getWholeResultE()),
      scheduledWorkFinishE: exactNumberDigits(getScheduledWorkE())
    }
  }
}

/**
 * 自動配分時に平均を取得
 */
const averageList = (splitNumber: number, value: number) => {
  const result: number[] = []
  // 労務数を分割業者数で除算したあまり
  const remainder = value % splitNumber
  // 労務数を分割業者数で除算した結果
  let perCount = value / splitNumber
  if (remainder === 0) {
    // あまりが発生しない場合、分割業者数分で除算した労務数を設定する
    Array.from({ length: splitNumber }).forEach(() => {
      result.push(perCount)
    })
  } else {
    // あまりが発生する場合、除算の整数部を取得し設定する
    perCount = (value - remainder) / splitNumber
    Array.from({ length: splitNumber }).forEach(() => {
      result.push(perCount)
    })
    // あまりを上から順に配分する
    Array.from({ length: remainder }).forEach((_item, index) => {
      result[index] = perCount + 1
    })
  }
  return result
}

export const ManualSimulationAllotment: FC = () => {
  useAccessibleAuthority(Authority.Builder, Authority.Material, Authority.Branch)
  usePageTitle('山積計算')
  // 労務山積計算情報取得
  const [workYamadumi, setWorkYamadumi] = useState<SimulationCalculationInfoResItem>()
  const [beforeWorkYamadumi, setBeforeWorkYamadumi] = useState<SimulationCalculationInfoResItem>()
  // 物件情報取得
  const [buildingInfo, setBuildingInfo] = useState<SimulationBuildingBuildingInfo>()
  // 山積結果取得
  const [manualYamadumiList, setManualYamadumiList] = useState<ManualYamadumiNewItem[]>([])
  const [beforeManualYamadumiList, setBeforeManualYamadumiList] = useState<ManualYamadumiNewItem[]>([])
  // 業者配分結果取得
  const [supplierInfo, setSupplierInfo] = useState<SupplierAllocationNewItem[]>([])
  const [beforeSupplierInfo, setBeforeSupplierInfo] = useState<SupplierAllocationNewItem[]>([])
  // 再検索フラグ
  const [searchFlg, setSearchFlg] = useState(false)
  // 変更検知
  const [isChanged, setIsChanged] = useState(false)
  // 表示開始年度取得
  const displayStartYear = useAppSelector((state) => state.common.displayStartYear)

  // ボタン制御
  const [isBottomConfirmDisabled, setIsBottomConfirmDisabled] = useState({ disable: false, display: true })
  const [isBottomTemporaryPreservationDisabled, setIsBottomTemporaryPreservationDisabled] = useState({ disable: false, display: true })
  const [isBottomHandProductClearDisabled, setIsBottomHandProductClearDisabled] = useState({ disable: false, display: true })
  const [isBottomAutomaticAllocationDisabled, setIsBottomAutomaticAllocationDisabled] = useState({ disable: false, display: true })
  const [isBottomEditAgainDisabled, setIsBottomEditAgainDisabled] = useState({ disable: false, display: true })
  const [isReadonlyDisabled, setIsReadonlyDisabled] = useState({ disable: false })
  const [isToggleDisabled, setIsToggleDisabled] = useState({ disable: false })
  // 確認ダイアログ
  const [confirmDialogOnAutoAllocationShow, setConfirmDialogOnAutoAllocationShow] = useState(false)
  const [confirmDialogGoBackShow, setConfirmDialogGoBackShow] = useState(false)
  const [confirmDialogUpdataDataShow, setConfirmDialogUpdataDataShow] = useState(false)
  const [confirmDialogUpdataDataMessage, setConfirmDialogUpdataDataMessage] = useState({ type: '', id: '', title: '', args: [''] })
  const allocationInfoStore = useAppSelector((state) => state.simulationbuildingsearch.allocationInfo)
  // メッセージ
  const [messages, setMessages] = useState<ErrorMessage[]>([])
  const [errorMessages, setErrorMessages] = useState<ErrorMessage[]>([])
  // ログイン情報の取得
  const userProp = useAppSelector((state) => state.common.userProp)
  // 画面遷移
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const autoCalculationMethod = workYamadumi?.autoCalculationMethod

  /**
   * 費目エリアの再計算
   */
  const handleExpenseAreaChange = (id: string, value: number | null) => {
    if (workYamadumi === undefined) return
    // 変更前のステートを保持する
    const inputData: SimulationCalculationInfoResItem = Object.assign({}, JSON.parse(JSON.stringify(workYamadumi)))

    if (workYamadumi.yamadumiAutoKbn === '1') {
      if (workYamadumi.autoCalculationMethod === 'A') {
        if (id === 'expenseCost') {
          // 費目工事金額を変更した場合
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 費目工事金額
              draft.expenseCost = value
            })
          )
        } else if (id === 'structureRatioFoundation') {
          // 構造比率-基礎を変更した場合
          inputData.structureRatioFoundation = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 構造比率-基礎
              draft.structureRatioFoundation = value
              // 施工数量-基礎
              draft.constructionQuantityFoundation = result?.constructionQuantityFoundationA === Infinity ||
                                          result?.constructionQuantityFoundationA === undefined ||
                                          isNaN(Number(result?.constructionQuantityFoundationA))
                ? null
                : result?.constructionQuantityFoundationA
              // 施工数量-全体
              draft.constructionQuantityAll = result?.wholeResultA === Infinity ||
                                          result?.wholeResultA === undefined ||
                                          isNaN(Number(result?.wholeResultA))
                ? null
                : result?.wholeResultA
              // 予定労務数-基礎
              draft.scheduledWorkFoundation = result?.scheduledWorkFoundationA === Infinity ||
                                          result?.scheduledWorkFoundationA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFoundationA))
                ? null
                : result?.scheduledWorkFoundationA
            })
          )
        } else if (id === 'structureRatioUnderground') {
          // 構造比率-地下を変更した場合
          inputData.structureRatioUnderground = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 構造比率-地下
              draft.structureRatioUnderground = value
              // 施工数量-基礎
              draft.constructionQuantityUnderground = result?.constructionQuantityUndergroundA === Infinity ||
                                          result?.constructionQuantityUndergroundA === undefined ||
                                          isNaN(Number(result?.constructionQuantityUndergroundA))
                ? null
                : result?.constructionQuantityUndergroundA
              // 施工数量-全体
              draft.constructionQuantityAll = result?.wholeResultA === Infinity ||
                                          result?.wholeResultA === undefined ||
                                          isNaN(Number(result?.wholeResultA))
                ? null
                : result?.wholeResultA
              // 予定労務数-地下
              draft.scheduledWorkUnderground = result?.scheduledWorkUndergroundA === Infinity ||
                                          result?.scheduledWorkUndergroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundA))
                ? null
                : result?.scheduledWorkUndergroundA
            })
          )
        } else if (id === 'structureRatioGround') {
          // 構造比率-地上を変更した場合
          inputData.structureRatioGround = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 構造比率-地上
              draft.structureRatioGround = value
              // 施工数量-地上
              draft.constructionQuantityGround = result?.constructionQuantityGroundA === Infinity ||
                                          result?.constructionQuantityGroundA === undefined ||
                                          isNaN(Number(result?.constructionQuantityGroundA))
                ? null
                : result?.constructionQuantityGroundA
              // 施工数量-全体
              draft.constructionQuantityAll = result?.wholeResultA === Infinity ||
                                          result?.wholeResultA === undefined ||
                                          isNaN(Number(result?.wholeResultA))
                ? null
                : result?.wholeResultA
              // 予定労務数-地上
              draft.scheduledWorkGround = result?.scheduledWorkGroundA === Infinity ||
                                          result?.scheduledWorkGroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundA))
                ? null
                : result?.scheduledWorkGroundA
            })
          )
        } else if (id === 'constructionQuantityFoundation') {
          // 施工数量-基礎を変更した場合
          inputData.constructionQuantityFoundation = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 施工数量-基礎
              draft.constructionQuantityFoundation = value
              // 施工数量-全体
              draft.constructionQuantityAll = result?.wholeResultA === Infinity ||
                                          result?.wholeResultA === undefined ||
                                          isNaN(Number(result?.wholeResultA))
                ? null
                : result?.wholeResultA
              // 予定労務数-基礎
              draft.scheduledWorkFoundation = result?.scheduledWorkFoundationA === Infinity ||
                                          result?.scheduledWorkFoundationA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFoundationA))
                ? null
                : result?.scheduledWorkFoundationA
            })
          )
        } else if (id === 'constructionQuantityUnderground') {
          // 施工数量-地下を変更した場合
          inputData.constructionQuantityUnderground = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 施工数量-地下
              draft.constructionQuantityUnderground = value
              // 施工数量-全体
              draft.constructionQuantityAll = result?.wholeResultA === Infinity ||
                                          result?.wholeResultA === undefined ||
                                          isNaN(Number(result?.wholeResultA))
                ? null
                : result?.wholeResultA
              // 予定労務数-地下
              draft.scheduledWorkUnderground = result?.scheduledWorkUndergroundA === Infinity ||
                                          result?.scheduledWorkUndergroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundA))
                ? null
                : result?.scheduledWorkUndergroundA
            })
          )
        } else if (id === 'constructionQuantityFloorPrecedence') {
          // 施工数量-先行床を変更した場合
          inputData.constructionQuantityFloorPrecedence = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 施工数量-先行床
              draft.constructionQuantityFloorPrecedence = value
              // 施工数量-全体
              draft.constructionQuantityAll = result?.wholeResultA === Infinity ||
                                          result?.wholeResultA === undefined ||
                                          isNaN(Number(result?.wholeResultA))
                ? null
                : result?.wholeResultA
              // 予定労務数-先行床
              draft.scheduledWorkFloorPrecedence = result?.scheduledWorkFloorPrecedenceA === Infinity ||
                                          result?.scheduledWorkFloorPrecedenceA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFloorPrecedenceA))
                ? null
                : result?.scheduledWorkFloorPrecedenceA
            })
          )
        } else if (id === 'constructionQuantityGround') {
          // 施工数量-地上を変更した場合
          inputData.constructionQuantityGround = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 施工数量-地上
              draft.constructionQuantityGround = value
              // 施工数量-全体
              draft.constructionQuantityAll = result?.wholeResultA === Infinity ||
                                          result?.wholeResultA === undefined ||
                                          isNaN(Number(result?.wholeResultA))
                ? null
                : result?.wholeResultA
              // 予定労務数-地上
              draft.scheduledWorkGround = result?.scheduledWorkGroundA === Infinity ||
                                          result?.scheduledWorkGroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundA))
                ? null
                : result?.scheduledWorkGroundA
            })
          )
        } else if (id === 'productionRateFoundation') {
          // 歩掛-基礎を変更した場合
          inputData.productionRateFoundation = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 歩掛-基礎
              draft.productionRateFoundation = value
              // 予定労務数-基礎
              draft.scheduledWorkFoundation = result?.scheduledWorkFoundationA === Infinity ||
                                          result?.scheduledWorkFoundationA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFoundationA))
                ? null
                : result?.scheduledWorkFoundationA
            })
          )
        } else if (id === 'productionRateUnderground') {
          // 歩掛-地下を変更した場合
          inputData.productionRateUnderground = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 歩掛-地下
              draft.productionRateUnderground = value
              // 予定労務数-地下
              draft.scheduledWorkUnderground = result?.scheduledWorkUndergroundA === Infinity ||
                                          result?.scheduledWorkUndergroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundA))
                ? null
                : result?.scheduledWorkUndergroundA
            })
          )
        } else if (id === 'productionRateFloorPrecedence') {
          // 歩掛-先行床を変更した場合
          inputData.productionRateFloorPrecedence = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 歩掛-先行床
              draft.productionRateFloorPrecedence = value
              // 予定労務数-先行床
              draft.scheduledWorkFloorPrecedence = result?.scheduledWorkFloorPrecedenceA === Infinity ||
                                          result?.scheduledWorkFloorPrecedenceA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFloorPrecedenceA))
                ? null
                : result?.scheduledWorkFloorPrecedenceA
            })
          )
        } else if (id === 'productionRateGround') {
          // 歩掛-地上を変更した場合
          inputData.productionRateGround = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 歩掛-地上
              draft.productionRateGround = value
              // 予定労務数-地上
              draft.scheduledWorkGround = result?.scheduledWorkGroundA === Infinity ||
                                          result?.scheduledWorkGroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundA))
                ? null
                : result?.scheduledWorkGroundA
            })
          )
        } else if (id === 'scheduleFoundation') {
          // 工期-基礎を変更した場合
          inputData.scheduleFoundation = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期-基礎
              draft.scheduleFoundation = value
              // 予定労務数-基礎
              draft.scheduledWorkFoundation = result?.scheduledWorkFoundationA === Infinity ||
                                          result?.scheduledWorkFoundationA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFoundationA))
                ? null
                : result?.scheduledWorkFoundationA
            })
          )
        } else if (id === 'scheduleUnderground') {
          // 工期-地下を変更した場合
          inputData.scheduleUnderground = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期-地下
              draft.scheduleUnderground = value
              // 予定労務数-地下
              draft.scheduledWorkUnderground = result?.scheduledWorkUndergroundA === Infinity ||
                                          result?.scheduledWorkUndergroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundA))
                ? null
                : result?.scheduledWorkUndergroundA
            })
          )
        } else if (id === 'scheduleFloorPrecedence') {
          // 工期-先行床を変更した場合
          inputData.scheduleFloorPrecedence = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期-先行床
              draft.scheduleFloorPrecedence = value
              // 予定労務数-先行床
              draft.scheduledWorkFloorPrecedence = result?.scheduledWorkFloorPrecedenceA === Infinity ||
                                          result?.scheduledWorkFloorPrecedenceA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFloorPrecedenceA))
                ? null
                : result?.scheduledWorkFloorPrecedenceA
            })
          )
        } else if (id === 'scheduleGround') {
          // 工期-地上を変更した場合
          inputData.scheduleGround = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期-地上
              draft.scheduleGround = value
              // 予定労務数-地上
              draft.scheduledWorkGround = result?.scheduledWorkGroundA === Infinity ||
                                          result?.scheduledWorkGroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundA))
                ? null
                : result?.scheduledWorkGroundA
            })
          )
        }
      } else if (workYamadumi.autoCalculationMethod === 'B') {
        if (id === 'expenseCost') {
          // 費目工事金額を変更した場合
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 費目工事金額
              draft.expenseCost = value
            })
          )
        } else if (id === 'costPerTsubo') {
          // 坪単価を変更した場合
          inputData.costPerTsubo = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 坪単価
              draft.costPerTsubo = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultB === Infinity ||
                                          result?.wholeResultB === undefined ||
                                          isNaN(Number(result?.wholeResultB))
                ? null
                : result?.wholeResultB
              // 予定労務数-準備
              draft.scheduledWorkPreparation = result?.scheduledWorkPreparationB === Infinity ||
                                          result?.scheduledWorkPreparationB === undefined ||
                                          isNaN(Number(result?.scheduledWorkPreparationB))
                ? null
                : result?.scheduledWorkPreparationB
              // 予定労務数-基礎・地下
              draft.scheduledWorkFoundationUnderground = result?.scheduledWorkUndergroundB === Infinity ||
                                          result?.scheduledWorkUndergroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundB))
                ? null
                : result?.scheduledWorkUndergroundB
              // 予定労務数-地上
              draft.scheduledWorkGround = result?.scheduledWorkGroundB === Infinity ||
                                          result?.scheduledWorkGroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundB))
                ? null
                : result?.scheduledWorkGroundB
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishB === Infinity ||
                                          result?.scheduledWorkFinishB === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishB))
                ? null
                : result?.scheduledWorkFinishB
            })
          )
        } else if (id === 'costPerWork') {
          // 労務単価を変更した場合
          inputData.costPerWork = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務単価
              draft.costPerWork = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultB === Infinity ||
                                          result?.wholeResultB === undefined ||
                                          isNaN(Number(result?.wholeResultB))
                ? null
                : result?.wholeResultB
              // 予定労務数-準備
              draft.scheduledWorkPreparation = result?.scheduledWorkPreparationB === Infinity ||
                                          result?.scheduledWorkPreparationB === undefined ||
                                          isNaN(Number(result?.scheduledWorkPreparationB))
                ? null
                : result?.scheduledWorkPreparationB
              // 予定労務数-基礎・地下
              draft.scheduledWorkFoundationUnderground = result?.scheduledWorkUndergroundB === Infinity ||
                                          result?.scheduledWorkUndergroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundB))
                ? null
                : result?.scheduledWorkUndergroundB
              // 予定労務数-地上
              draft.scheduledWorkGround = result?.scheduledWorkGroundB === Infinity ||
                                          result?.scheduledWorkGroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundB))
                ? null
                : result?.scheduledWorkGroundB
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishB === Infinity ||
                                          result?.scheduledWorkFinishB === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishB))
                ? null
                : result?.scheduledWorkFinishB
            })
          )
        } else if (id === 'workRatioPreparation') {
          // 労務比率-準備を変更した場合
          inputData.workRatioPreparation = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務比率-準備
              draft.workRatioPreparation = value
              // 予定労務数-準備
              draft.scheduledWorkPreparation = result?.scheduledWorkPreparationB === Infinity ||
                                          result?.scheduledWorkPreparationB === undefined ||
                                          isNaN(Number(result?.scheduledWorkPreparationB))
                ? null
                : result?.scheduledWorkPreparationB
            })
          )
        } else if (id === 'workRatioFoundationUnderground') {
          // 労務比率-基礎・地下を変更した場合
          inputData.workRatioFoundationUnderground = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務比率-基礎・地下
              draft.workRatioFoundationUnderground = value
              // 予定労務数-基礎・地下
              draft.scheduledWorkFoundationUnderground = result?.scheduledWorkUndergroundB === Infinity ||
                                          result?.scheduledWorkUndergroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundB))
                ? null
                : result?.scheduledWorkUndergroundB
            })
          )
        } else if (id === 'workRatioGround') {
          // 労務比率-地上を変更した場合
          inputData.workRatioGround = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務比率-地上
              draft.workRatioGround = value
              // 予定労務数-地上
              draft.scheduledWorkGround = result?.scheduledWorkGroundB === Infinity ||
                                          result?.scheduledWorkGroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundB))
                ? null
                : result?.scheduledWorkGroundB
            })
          )
        } else if (id === 'workRatioFinish') {
          // 労務比率-仕上げを変更した場合
          inputData.workRatioFinish = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務比率-仕上げ
              draft.workRatioFinish = value
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishB === Infinity ||
                                          result?.scheduledWorkFinishB === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishB))
                ? null
                : result?.scheduledWorkFinishB
            })
          )
        } else if (id === 'scheduleRatioPreparation') {
          // 工期比率-準備を変更した場合
          inputData.scheduleRatioPreparation = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期比率-準備
              draft.scheduleRatioPreparation = value
              // 予定労務数-準備
              draft.scheduledWorkPreparation = result?.scheduledWorkPreparationB === Infinity ||
                                          result?.scheduledWorkPreparationB === undefined ||
                                          isNaN(Number(result?.scheduledWorkPreparationB))
                ? null
                : result?.scheduledWorkPreparationB
            })
          )
        } else if (id === 'scheduleRatioFoundationUnderground') {
          // 工期比率-基礎・地下を変更した場合
          inputData.scheduleRatioFoundationUnderground = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期比率-基礎・地下
              draft.scheduleRatioFoundationUnderground = value
              // 予定労務数-基礎・地下
              draft.scheduledWorkFoundationUnderground = result?.scheduledWorkUndergroundB === Infinity ||
                                          result?.scheduledWorkUndergroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundB))
                ? null
                : result?.scheduledWorkUndergroundB
            })
          )
        } else if (id === 'scheduleRatioGround') {
          // 工期比率-地上を変更した場合
          inputData.scheduleRatioGround = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期比率-地上
              draft.scheduleRatioGround = value
              // 予定労務数-地上
              draft.scheduledWorkGround = result?.scheduledWorkGroundB === Infinity ||
                                          result?.scheduledWorkGroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundB))
                ? null
                : result?.scheduledWorkGroundB
            })
          )
        } else if (id === 'scheduleRatioFinish') {
          // 労務比率-仕上げを変更した場合
          inputData.scheduleRatioFinish = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期比率-仕上げ
              draft.scheduleRatioFinish = value
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishB === Infinity ||
                                          result?.scheduledWorkFinishB === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishB))
                ? null
                : result?.scheduledWorkFinishB
            })
          )
        }
      } else if (workYamadumi.autoCalculationMethod === 'C') {
        if (id === 'expenseCost') {
          // 費目工事金額を変更した場合
          inputData.expenseCost = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 費目工事金額
              draft.expenseCost = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultC === Infinity ||
                                          result?.wholeResultC === undefined ||
                                          isNaN(Number(result?.wholeResultC))
                ? null
                : result?.wholeResultC
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishC === Infinity ||
                                          result?.scheduledWorkFinishC === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishC))
                ? null
                : result?.scheduledWorkFinishC
              // 予定労務数-その他
              draft.scheduledWorkOther = result?.scheduledWorkOtherC === Infinity ||
                                          result?.scheduledWorkOtherC === undefined ||
                                          isNaN(Number(result?.scheduledWorkOtherC))
                ? null
                : result?.scheduledWorkOtherC
            })
          )
        } else if (id === 'costPerWork') {
          // 労務単価を変更した場合
          inputData.costPerWork = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務単価
              draft.costPerWork = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultC === Infinity ||
                                          result?.wholeResultC === undefined ||
                                          isNaN(Number(result?.wholeResultC))
                ? null
                : result?.wholeResultC
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishC === Infinity ||
                                          result?.scheduledWorkFinishC === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishC))
                ? null
                : result?.scheduledWorkFinishC
              // 予定労務数-その他
              draft.scheduledWorkOther = result?.scheduledWorkOtherC === Infinity ||
                                          result?.scheduledWorkOtherC === undefined ||
                                          isNaN(Number(result?.scheduledWorkOtherC))
                ? null
                : result?.scheduledWorkOtherC
            })
          )
        } else if (id === 'scheduleRatioFinish') {
          // 工期比率を変更した場合
          inputData.scheduleRatioFinish = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期比率
              draft.scheduleRatioFinish = value
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishC === Infinity ||
                                          result?.scheduledWorkFinishC === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishC))
                ? null
                : result?.scheduledWorkFinishC
              // 予定労務数-その他
              draft.scheduledWorkOther = result?.scheduledWorkOtherC === Infinity ||
                                          result?.scheduledWorkOtherC === undefined ||
                                          isNaN(Number(result?.scheduledWorkOtherC))
                ? null
                : result?.scheduledWorkOtherC
            })
          )
        } else if (id === 'scheduledWorkFinish') {
          // 予定労務数-仕上げを変更した場合
          inputData.scheduledWorkFinish = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = value
              // 予定労務数-その他
              draft.scheduledWorkOther = result?.scheduledWorkOtherC === Infinity ||
                                          result?.scheduledWorkOtherC === undefined ||
                                          isNaN(Number(result?.scheduledWorkOtherC))
                ? null
                : result?.scheduledWorkOtherC
            })
          )
        } else if (id === 'scheduledWorkOther') {
          // 予定労務数-その他を変更した場合
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 予定労務数-その他
              draft.scheduledWorkOther = value
            })
          )
        } else if (id === 'constant') {
          // 定数を変更した場合
          inputData.constant = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 定数
              draft.constant = value
              // 予定労務数-その他
              draft.scheduledWorkOther = result?.scheduledWorkOtherC === Infinity ||
                                          result?.scheduledWorkOtherC === undefined ||
                                          isNaN(Number(result?.scheduledWorkOtherC))
                ? null
                : result?.scheduledWorkOtherC
            })
          )
        }
      } else if (workYamadumi.autoCalculationMethod === 'D') {
        if (id === 'expenseCost') {
          // 費目工事金額を変更した場合
          inputData.expenseCost = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 費目工事金額
              draft.expenseCost = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultD === Infinity ||
                                          result?.wholeResultD === undefined ||
                                          isNaN(Number(result?.wholeResultD))
                ? null
                : result?.wholeResultD
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishD === Infinity ||
                                          result?.scheduledWorkFinishD === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishD))
                ? null
                : result?.scheduledWorkFinishD
            })
          )
        } else if (id === 'costPerWork') {
          // 労務単価を変更した場合
          inputData.costPerWork = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務単価
              draft.costPerWork = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultD === Infinity ||
                                          result?.wholeResultD === undefined ||
                                          isNaN(Number(result?.wholeResultD))
                ? null
                : result?.wholeResultD
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishD === Infinity ||
                                          result?.scheduledWorkFinishD === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishD))
                ? null
                : result?.scheduledWorkFinishD
            })
          )
        } else if (id === 'scheduleRatioFinish') {
          // 工期比率を変更した場合
          inputData.scheduleRatioFinish = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期比率
              draft.scheduleRatioFinish = value
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishD === Infinity ||
                                          result?.scheduledWorkFinishD === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishD))
                ? null
                : result?.scheduledWorkFinishD
            })
          )
        } else if (id === 'scheduledWorkFinish') {
          // 予定労務数-仕上げを変更した場合
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = value
            })
          )
        }
      } else if (workYamadumi.autoCalculationMethod === 'E') {
        if (id === 'expenseCost') {
          // 費目工事金額を変更した場合
          inputData.expenseCost = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 費目工事金額
              draft.expenseCost = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultE === Infinity ||
                                          result?.wholeResultE === undefined ||
                                          isNaN(Number(result?.wholeResultE))
                ? null
                : result?.wholeResultE
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishE === Infinity ||
                                          result?.scheduledWorkFinishE === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishE))
                ? null
                : result?.scheduledWorkFinishE
            })
          )
        } else if (id === 'costPerTsubo') {
          // 坪単価を変更した場合
          inputData.costPerTsubo = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 坪単価
              draft.costPerTsubo = value
              // 費目工事金額
              draft.expenseCost = result?.expenseCostE === Infinity ||
                                    result?.expenseCostE === undefined ||
                                    isNaN(Number(result?.expenseCostE))
                ? null
                : result?.expenseCostE
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultE === Infinity ||
                                          result?.wholeResultE === undefined ||
                                          isNaN(Number(result?.wholeResultE))
                ? null
                : result?.wholeResultE
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishE === Infinity ||
                                          result?.scheduledWorkFinishE === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishE))
                ? null
                : result?.scheduledWorkFinishE
            })
          )
        } else if (id === 'constant') {
          // 定数を変更した場合
          inputData.constant = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 定数
              draft.constant = value
              // 費目工事金額
              draft.expenseCost = result?.expenseCostE === Infinity ||
                                    result?.expenseCostE === undefined ||
                                    isNaN(Number(result?.expenseCostE))
                ? null
                : result?.expenseCostE
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultE === Infinity ||
                                          result?.wholeResultE === undefined ||
                                          isNaN(Number(result?.wholeResultE))
                ? null
                : result?.wholeResultE
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishE === Infinity ||
                                          result?.scheduledWorkFinishE === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishE))
                ? null
                : result?.scheduledWorkFinishE
            })
          )
        } else if (id === 'safeRatio') {
          // 安全率を変更した場合
          inputData.safeRatio = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 安全率
              draft.safeRatio = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultE === Infinity ||
                                          result?.wholeResultE === undefined ||
                                          isNaN(Number(result?.wholeResultE))
                ? null
                : result?.wholeResultE
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishE === Infinity ||
                                          result?.scheduledWorkFinishE === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishE))
                ? null
                : result?.scheduledWorkFinishE
            })
          )
        } else if (id === 'workRatioFinish') {
          // 労務比率を変更した場合
          inputData.workRatioFinish = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務数比率
              draft.workRatioFinish = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultE === Infinity ||
                                          result?.wholeResultE === undefined ||
                                          isNaN(Number(result?.wholeResultE))
                ? null
                : result?.wholeResultE
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishE === Infinity ||
                                          result?.scheduledWorkFinishE === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishE))
                ? null
                : result?.scheduledWorkFinishE
            })
          )
        } else if (id === 'costPerWork') {
          // 労務単価を変更した場合
          inputData.costPerWork = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 労務単価
              draft.costPerWork = value
              // 全体予定労務数
              draft.scheduledWorkAll = result?.wholeResultE === Infinity ||
                                          result?.wholeResultE === undefined ||
                                          isNaN(Number(result?.wholeResultE))
                ? null
                : result?.wholeResultE
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishE === Infinity ||
                                          result?.scheduledWorkFinishE === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishE))
                ? null
                : result?.scheduledWorkFinishE
            })
          )
        } else if (id === 'scheduleRatioFinish') {
          // 工期比率を変更した場合
          inputData.scheduleRatioFinish = value
          const result = creatWholeResult(
            autoCalculationMethod ?? '',
            buildingInfo?.schedule ?? 0,
            buildingInfo?.totalFloorAreaM2 ?? 0,
            buildingInfo?.totalFloorAreaTsubo ?? 0,
            inputData,
            true
          )
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 工期比率
              draft.scheduleRatioFinish = value
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = result?.scheduledWorkFinishE === Infinity ||
                                          result?.scheduledWorkFinishE === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishE))
                ? null
                : result?.scheduledWorkFinishE
            })
          )
        } else if (id === 'scheduledWorkFinish') {
          // 予定労務数-仕上げを変更した場合
          setWorkYamadumi(
            produce((draft) => {
              if (draft === undefined) return
              // 予定労務数-仕上げ
              draft.scheduledWorkFinish = value
            })
          )
        }
      }
    }
  }

  /**
   * 表示
   */
  const handleOnDisplayCheckboxChange = useCallback((
    selectedRowIndex: number,
    selected: boolean
  ) => {
    setManualYamadumiList(
      produce((draft) => {
        draft[selectedRowIndex].displayFlg = selected ? 1 : 0
      })
    )
  }, [manualYamadumiList])

  /**
   * 自動配分フラグ
   */
  const handleOnAutoAllocationCheckboxChange = useCallback((
    selectedRowIndex: number,
    selected: boolean
  ) => {
    setManualYamadumiList(
      produce((draft) => {
        draft[selectedRowIndex].autoAllocationFlg = selected ? 1 : 0
      })
    )
  }, [manualYamadumiList])

  /**
   * 分割業者数
   */
  const handleOnSplitSupplierNumberChange = useCallback((
    selectedRowIndex: number,
    splitSupplierNumber: number
  ) => {
    setManualYamadumiList(
      produce((draft) => {
        draft[selectedRowIndex].splitSupplierNumber = splitSupplierNumber
      })
    )
  }, [manualYamadumiList])

  /**
   * 開始年
   */
  const handleOnChangeYear = useCallback((
    selectedRowIndex: number,
    year: string,
    month: string
  ) => {
    setManualYamadumiList(
      produce((draft) => {
        draft[selectedRowIndex].startYm = year + month.toString()
      })
    )
  }, [manualYamadumiList])

  /**
   * 開始月
   */
  const handleOnChangeMonth = useCallback((
    selectedRowIndex: number,
    year: string,
    month: string
  ) => {
    setManualYamadumiList(
      produce((draft) => {
        draft[selectedRowIndex].startYm = year + month.toString()
      })
    )
  }, [manualYamadumiList])

  /**
   * 工期月数
   */
  const handleOnScheduleMonthsNumberChange = useCallback((
    selectedRowIndex: number,
    scheduleMonthsNumber: number
  ) => {
    setManualYamadumiList(
      produce((draft) => {
        draft[selectedRowIndex].scheduleMonths = scheduleMonthsNumber
      })
    )
  }, [manualYamadumiList])

  /**
   * 分割ボタン押下
   */
  const handleSplit = useCallback((
    item: ManualYamadumiNewItem
  ) => {
    let lastSamePartKbnIndex = 0
    let lastPartSeq: number | null = 0
    manualYamadumiList?.map((_item, _index) => {
      if (_item.partKbn === item.partKbn) {
        lastSamePartKbnIndex = _index
        lastPartSeq = _item.partSeq
      }
      return _item
    })
    setManualYamadumiList(
      produce((draft) => {
        draft?.splice(lastSamePartKbnIndex + 1, 0, {
          summaryFlg: 1,
          updDtm: null,
          partKbn: item.partKbn,
          partGroup: item.partGroup,
          partSeq: Number(lastPartSeq) + 1,
          autoAllocationFlg: 0,
          displayFlg: 0,
          display: 'block',
          partNm: null,
          splitSupplierNumber: null,
          startYm: null,
          scheduleMonths: null,
          workQuantity: produce(
            _initDataWorkQuantityTypeObj,
            (draftInitDataWorkQuantityTypeObj) => {
              draftInitDataWorkQuantityTypeObj.map((item) => {
                item.readOnly = false
                return item
              })
            }
          )
        })
      })
    )
  }, [manualYamadumiList])

  /**
   * 手積反映
   */
  const handleResultDateList = useCallback((resultIndexList: Array<number | null>, rowNo: number) => {
    setManualYamadumiList(
      produce((draft) => {
        draft[rowNo].workQuantity =
          draft[rowNo]?.workQuantity?.map((item, itemIndex) => {
            item.value = null
            resultIndexList?.forEach((elIndex) => {
              if (elIndex === itemIndex && workYamadumi !== undefined) {
                if (workYamadumi.autoCalculationMethod === 'A') {
                  if (manualYamadumiList?.[rowNo]?.partGroup === '1') {
                    item.value = workYamadumi.scheduledWorkFoundation ?? 0
                  }
                  if (manualYamadumiList?.[rowNo].partGroup === '2') {
                    item.value = workYamadumi.scheduledWorkUnderground ?? 0
                  }
                  if (manualYamadumiList?.[rowNo].partGroup === '3') {
                    item.value = workYamadumi.scheduledWorkGround ?? 0
                  }
                  return
                }
                if (workYamadumi.autoCalculationMethod === 'B') {
                  if (manualYamadumiList?.[rowNo].partGroup === '5') {
                    item.value = workYamadumi.scheduledWorkPreparation ?? 0
                  }
                  if (manualYamadumiList?.[rowNo].partGroup === '6') {
                    item.value = workYamadumi.scheduledWorkFoundationUnderground ?? 0
                  }
                  if (manualYamadumiList?.[rowNo].partGroup === '7') {
                    item.value = workYamadumi.scheduledWorkGround ?? 0
                  }
                  if (manualYamadumiList?.[rowNo].partGroup === '8') {
                    item.value = workYamadumi.scheduledWorkFinish ?? 0
                  }
                  return
                }
                if (
                  workYamadumi.autoCalculationMethod === 'C' ||
                  workYamadumi.autoCalculationMethod === 'D' ||
                  workYamadumi.autoCalculationMethod === 'E'
                ) {
                  if (
                    manualYamadumiList?.[rowNo].partGroup === '8' &&
                    manualYamadumiList?.[rowNo].partKbn === '4'
                  ) {
                    item.value = workYamadumi.scheduledWorkOther ?? 0
                  }
                  if (
                    manualYamadumiList?.[rowNo].partGroup === '8' &&
                    manualYamadumiList?.[rowNo].partKbn !== '4'
                  ) {
                    item.value = workYamadumi.scheduledWorkFinish ?? 0
                  }
                }
              }
            })
            return item
          }) ?? []
      })
    )
  }, [manualYamadumiList, workYamadumi])

  /**
   * manualYamadumiList M1 CellsChanged
   */
  const handleOnCellsChangedManualSimulationSheet = useCallback((
    arrayOfChanges: ReactDataSheet.CellsChangedArgs<GridElement, CellValue>
  ) => {
    if (isNaN(Number(arrayOfChanges[0]?.value))) return
    setManualYamadumiList(
      produce((draft) => {
        arrayOfChanges.forEach(({ row, col, value }) => {
          if (draft[row].workQuantity !== null) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            draft[row].workQuantity![col].value = value
          }
        })
      })
    )
  }, [manualYamadumiList])

  /**
   * 非表示
   */
  const handleNotAllDisplay = useCallback(() => {
    setManualYamadumiList(
      produce((draft) => {
        draft?.map((item) => {
          item.display = item?.displayFlg === 1 ? 'block' : 'none'
          return item
        })
      })
    )
  }, [manualYamadumiList])

  /**
   * 全表示
   */
  const handleAllDisplay = useCallback(() => {
    setManualYamadumiList(
      produce((draft) => {
        draft?.map((item) => {
          item.display = 'block'
          return item
        })
      })
    )
  }, [manualYamadumiList])

  /**
   *  フッターボタン押下時の確認ダイアログ表示
   */
  const handleUpdataData = (
    type: string,
    id: string,
    title: string,
    args: string[]
  ) => {
    setConfirmDialogUpdataDataShow(true)
    setConfirmDialogUpdataDataMessage({
      type,
      id,
      title,
      args
    })
  }

  /**
   *  フッターボタン確認ダイアログOK押下時
   */
  const dialogConfirmUpdataDataBtn = () => {
    setConfirmDialogUpdataDataShow(false)
    if (workYamadumi === undefined) return
    if (confirmDialogUpdataDataMessage.type === '3') {
      // 費目要否
      setIsToggleDisabled(
        produce((draft) => {
          draft.disable = false
        })
      )
    }
    /**
     * "1"(確定)、"2"(一時保存)、"3"(取戻)、"4"(削除)、"5"(優先度切替)
     */
    if (confirmDialogUpdataDataMessage.type === '5') {
      dispatch(CommonActions.setIsLoading(true))
      let flg: boolean = true
      YamadumiAutoPriorityGateway.putYamadumiAutoPriority(
        {
          data: {
            simulationYm: allocationInfoStore.simulationYm,
            procurementNo: allocationInfoStore.procurementNo,
            subNo: allocationInfoStore.subNo,
            branchCd: allocationInfoStore.branchCd,
            expense: allocationInfoStore.expense,
            expenseSeq: allocationInfoStore.expenseSeq,
            priorityKbnAfterChange: workYamadumi.priorityKbn === '1' ? '2' : '1'
          }
        }
      )
        .then((res) => {
          if (res.error) {
            flg = false
            if (Array.isArray(res.messages) && res.messages.length > 0) {
              const errorMessages = res.messages.map<ErrorMessage>((message) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              setErrorMessages(errorMessages)
            }
          }
        })
        .finally(() => {
          dispatch(CommonActions.setIsLoading(false))
          if (flg) {
            // 優先度切替後の遷移であることを示すためにストア書き換える
            dispatch(
              SimulationBuildingSearchActions.setPriorityStatus(true)
            )
            // 1つ前の画面に遷移する
            navigate(-1)
          }
        })
    } else {
      const putManualSimulationAllotmentReq = produce(
        putManualSimulationAllotmentData,
        (draftData) => {
          // 実行情報
          draftData.data.execInfo.execKbn = confirmDialogUpdataDataMessage.type
          // 更新条件
          draftData.data.updCondition.simulationYm = allocationInfoStore.simulationYm
          draftData.data.updCondition.procurementNo = allocationInfoStore.procurementNo
          draftData.data.updCondition.subNo = allocationInfoStore.subNo
          draftData.data.updCondition.branchCd = allocationInfoStore.branchCd
          draftData.data.updCondition.expense = allocationInfoStore.expense
          draftData.data.updCondition.expenseSeq = allocationInfoStore.expenseSeq
          draftData.data.updCondition.displayStartYear = displayStartYear
          // 費目情報
          draftData.data.expenseInfo.updDtm = workYamadumi.updDtm
          draftData.data.expenseInfo.monthWorkday = workYamadumi.monthWorkday
          draftData.data.expenseInfo.expenseNotApplicableFlg = workYamadumi.expenseNotApplicableFlg
          draftData.data.expenseInfo.expenseCost = workYamadumi.expenseCost
          draftData.data.expenseInfo.remark = workYamadumi.remark
          draftData.data.expenseInfo.structureRatioFoundation = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.structureRatioFoundation : null
          draftData.data.expenseInfo.structureRatioUnderground = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.structureRatioUnderground : null
          draftData.data.expenseInfo.structureRatioGround = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.structureRatioGround : null
          draftData.data.expenseInfo.constructionQuantityFoundation = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.constructionQuantityFoundation : null
          draftData.data.expenseInfo.constructionQuantityUnderground = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.constructionQuantityUnderground : null
          draftData.data.expenseInfo.constructionQuantityFloorPrecedence = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.constructionQuantityFloorPrecedence : null
          draftData.data.expenseInfo.constructionQuantityGround = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.constructionQuantityGround : null
          draftData.data.expenseInfo.productionRateFoundation = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.productionRateFoundation : null
          draftData.data.expenseInfo.productionRateUnderground = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.productionRateUnderground : null
          draftData.data.expenseInfo.productionRateFloorPrecedence = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.productionRateFloorPrecedence : null
          draftData.data.expenseInfo.productionRateGround = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.productionRateGround : null
          draftData.data.expenseInfo.scheduleFoundation = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.scheduleFoundation : null
          draftData.data.expenseInfo.scheduleUnderground = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.scheduleUnderground : null
          draftData.data.expenseInfo.scheduleFloorPrecedence = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.scheduleFloorPrecedence : null
          draftData.data.expenseInfo.scheduleGround = workYamadumi.autoCalculationMethod === 'A' ? workYamadumi.scheduleGround : null
          draftData.data.expenseInfo.costPerTsubo = (workYamadumi.autoCalculationMethod === 'B' || workYamadumi.autoCalculationMethod === 'E') ? workYamadumi.costPerTsubo : null
          draftData.data.expenseInfo.costPerWork = workYamadumi.autoCalculationMethod !== 'A' ? workYamadumi.costPerWork : null
          draftData.data.expenseInfo.workRatioPreparation = workYamadumi.autoCalculationMethod === 'B' ? workYamadumi.workRatioPreparation : null
          draftData.data.expenseInfo.workRatioFoundationUnderground = workYamadumi.autoCalculationMethod === 'B' ? workYamadumi.workRatioFoundationUnderground : null
          draftData.data.expenseInfo.workRatioGround = workYamadumi.autoCalculationMethod === 'B' ? workYamadumi.workRatioGround : null
          draftData.data.expenseInfo.workRatioFinish = (workYamadumi.autoCalculationMethod === 'B' || workYamadumi.autoCalculationMethod === 'E') ? workYamadumi.workRatioFinish : null
          draftData.data.expenseInfo.scheduleRatioPreparation = workYamadumi.autoCalculationMethod === 'B' ? workYamadumi.scheduleRatioPreparation : null
          draftData.data.expenseInfo.scheduleRatioFoundationUnderground = workYamadumi.autoCalculationMethod === 'B' ? workYamadumi.scheduleRatioFoundationUnderground : null
          draftData.data.expenseInfo.scheduleRatioGround = workYamadumi.autoCalculationMethod === 'B' ? workYamadumi.scheduleRatioGround : null
          draftData.data.expenseInfo.scheduleRatioFinish = workYamadumi.autoCalculationMethod !== 'A' ? workYamadumi.scheduleRatioFinish : null
          draftData.data.expenseInfo.scheduledWorkOther = workYamadumi.autoCalculationMethod === 'C' ? workYamadumi.scheduledWorkOther : null
          draftData.data.expenseInfo.scheduledWorkFinish = (workYamadumi.autoCalculationMethod === 'C' || workYamadumi.autoCalculationMethod === 'D' || workYamadumi.autoCalculationMethod === 'E') ? workYamadumi.scheduledWorkFinish : null
          draftData.data.expenseInfo.constant = (workYamadumi.autoCalculationMethod === 'C' || workYamadumi.autoCalculationMethod === 'E') ? workYamadumi.constant : null
          draftData.data.expenseInfo.safeRatio = workYamadumi.autoCalculationMethod === 'E' ? workYamadumi.safeRatio : null
          // 手積山積一覧
          // @ts-expect-error:next-line
          draftData.data.manualYamadumiList = produce(
            manualYamadumiList?.filter((x) => x.summaryFlg === 1),
            (draft) => {
              draft.forEach((item) => {
                const workQuantity: number[] = []
                item?.workQuantity?.forEach((el: { value: number | null }) => {
                  workQuantity.push(Number(el?.value) ?? 0)
                })
                // @ts-expect-error:next-line
                item.workQuantity = workQuantity
              })
            }
          )
          // 業者配分一覧
          draftData.data.allocationSupplierList = produce(supplierInfo?.filter((x) => x.summaryFlg === 1),
            (draft) => {
              draft.map((item) => {
                const workQuantity: number[] = []
                item?.workQuantity?.forEach((el) => {
                  workQuantity.push(Number(el?.value) ?? 0)
                })
                // @ts-expect-error:next-line
                item.workQuantity = workQuantity
                return item
              })
            })
        }

      )
      // 登録処理を実行する
      apiPostSimulationYamadumi(putManualSimulationAllotmentReq)
    }
  }

  /**
   * 戻るボタン押下
   */
  const handleGoBack = () => {
    if (buildingInfo?.opportunityProgressKbn === '1' && isChanged) {
      // 自動山積状態で変更検知している場合、useLeaveGuard使用時と同様のメッセージを表示する
      const ok = confirm('内容が編集中です。このページを離れますか？')
      if (ok) {
        navigate(-1)
      }
    } else if (workYamadumi?.decisionFlg === 1 || buildingInfo?.opportunityProgressKbn === '1') {
      // 確定済または変更なしの状態で自動山積の場合は、1つ前の画面に遷移する
      navigate(-1)
    } else {
      // 上記以外の場合は、一時保存ダイアログを表示する
      setConfirmDialogGoBackShow(true)
    }
  }

  /**
   * 戻るボタン押下時の一時保存確認ダイアログはい押下時
   */
  const dialogConfirmGoBackBtn = () => {
    setConfirmDialogGoBackShow(false)
    // 1つ前の画面に遷移する
    navigate(-1)
  }
  /**
   * M2 CellsChanged
   */
  const handleonCellsChangedM2 = useCallback((
    arrayOfChanges: Array<{ row: number, col: number, value: number | null }>
  ) => {
    if (isNaN(Number(arrayOfChanges[0]?.value))) return
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        arrayOfChanges.forEach(({ row, col, value }) => {
          if (draft[row].workQuantity !== null) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            draft[row].workQuantity![col].value = value
          }
        })
      })
    )
  }, [supplierInfo])
  /**
   * M2 業者追加ボタン押下
   */
  const onAddRowBtnM2Click = useCallback(() => {
    const AddRowM2DataSheet = produce(
      _initM2DataSheetList,
      (draftInitM2DataSheetList) => {
        draftInitM2DataSheetList.displayOrder = supplierInfo.length + 1
        draftInitM2DataSheetList.workQuantity?.forEach((item) => {
          item.readOnly = false
        })
      }
    )
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        draft?.push(AddRowM2DataSheet)
      })
    )
  }, [supplierInfo])
  /**
   * M2 見積業者一括選択ボタン押下
   */
  const onBulkAddRowBtnM2Click = useCallback(() => {
    SearchSupplierGateway.getSearchSupplierList(undefined, allocationInfoStore.expense)
      .then((res) => {
        if (!res.error) {
          // 現在M2に表示されている業者リストを取得する
          const copy: SupplierAllocationNewItem[] = supplierInfo.map((obj) => Object.assign({}, JSON.parse(JSON.stringify(obj))))
          // 初期表示時の空行が存在する場合、空行を削除する
          const existRow = copy.filter(x => !(x.pendingFlg === 0 && x.supplierCd === '' && x.supplierBranchCd === ''))
          // 現在M2に表示されている業者の業者コードと業者支店コードを取得する
          const list = copy.map((i) => {
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            return i.supplierCd + (i.supplierBranchCd ?? '')
          })
          // 一括追加業者リストからすでにM2に存在している業者を除外する
          // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
          const newSupplierList = res.data.supplierList.filter(x => !list.includes(x.supplierCd + x.supplierBranchCd))
          // 整形する
          const supplierList = newSupplierList.map((supplier, index) => {
            const newRow = _initM2DataSheetList
            return {
              ...newRow,
              supplierCd: supplier.supplierCd,
              supplierBranchCd: supplier.supplierBranchCd,
              supplierNm: supplier.supplierBranchNm === null ? `${supplier.supplierNm}` : `${supplier.supplierNm}  ${supplier.supplierBranchNm ?? ''}`,
              estimationBuildingFlg: 1,
              displayOrder: copy.length + 1 + index
            }
          })
          setSupplierInfo(
            produce((draft: SupplierAllocationNewItem[]) => {
              // 全行削除する
              draft.splice(0)
              // 初期表示空行を除く既存行を追加する
              existRow.forEach((item) => {
                draft.push(item)
              })
              // 新規業者を追加する
              supplierList.forEach((item) => {
                draft?.push(item)
              })
            })
          )
        } else {
          if (Array.isArray(res.messages) && res.messages.length > 0) {
            const errorMessages = res.messages.map<ErrorMessage>((message) => {
              return {
                id: message.id,
                content: message.message
              }
            })
            setErrorMessages(errorMessages)
          }
        }
      })
      .finally(() => {})
  }, [supplierInfo])
  /**
   * 削除フラグ
   */
  const handleOnDelCheckboxChange = useCallback((
    selectedRowIndex: number,
    selected: boolean
  ) => {
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        draft[selectedRowIndex].delFlg = selected ? 0 : 1
        if (!selected) {
          draft[selectedRowIndex].supplierCd = draft[selectedRowIndex].preChangeSupplier
          draft[selectedRowIndex].supplierNm = draft[selectedRowIndex].preChangeSupplierNm
          draft[selectedRowIndex].supplierBranchCd = draft[selectedRowIndex].preChangeSupplierBranchCd
        }
      })
    )
  }, [supplierInfo])
  /**
   * 業者
   */
  const handleOnRowSupplierNmChange = useCallback((supplierNm: string, supplierCd: string, supplierBranchCd: string | null, rowNo: number) => {
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        draft[rowNo].supplierNm = supplierNm
        draft[rowNo].supplierCd = supplierCd
        draft[rowNo].supplierBranchCd = supplierBranchCd
      })
    )
  }, [supplierInfo])
  /**
   * 未決フラグ
   */
  const handleOnPendingCheckboxChange = useCallback((
    selectedRowIndex: number,
    selected: boolean
  ) => {
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        draft[selectedRowIndex].pendingFlg = selected ? 0 : 1
      })
    )
  }, [supplierInfo])
  /**
   * 非公開フラグ
   */
  const handleOnUnpublishedCheckboxChange = useCallback((
    selectedRowIndex: number,
    selected: boolean
  ) => {
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        draft[selectedRowIndex].unpublishedFlg = selected ? 0 : 1
      })
    )
  }, [supplierInfo])
  /**
   * 推薦業者フラグ
   */
  const handleonRecommendationSupplierCheckboxChange = useCallback((
    selectedRowIndex: number,
    selected: boolean
  ) => {
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        draft[selectedRowIndex].recommendationSupplierFlg = selected ? 0 : 1
      })
    )
  }, [supplierInfo])
  /**
   * 見積物件フラグ
   */
  const handleEstimationBuildingSupplierFlgCheckboxChange = useCallback((
    selectedRowIndex: number,
    selected: boolean
  ) => {
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        draft[selectedRowIndex].estimationBuildingFlg = selected ? 0 : 1
      })
    )
  }, [supplierInfo])
  /**
   * 業者決定物件フラグ
   */
  const handleSupplierDecisionBuildingCheckboxChange = useCallback((
    selectedRowIndex: number,
    selected: boolean
  ) => {
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        draft[selectedRowIndex].supplierDecisionBuildingFlg = selected ? 0 : 1
      })
    )

    // 業者決定物件フラグがONになった場合、画面の制御を行う
    if (!selected) {
      setSupplierInfo(
        produce((draft) => {
          draft[selectedRowIndex].workQuantity?.forEach((item) => {
            item.readOnly = true
          })
          draft[selectedRowIndex].estimationBuildingFlg = 0
        })
      )
    } else {
      // 業者決定物件フラグがOFFになった場合、画面の制御を行う
      setSupplierInfo(
        produce((draft) => {
          draft[selectedRowIndex].workQuantity?.forEach((item) => {
            item.readOnly = false
          })
        })
      )
    }
  }, [supplierInfo])

  /**
   * 自動配分ボタン押下ダイアログ
   */
  const handleOnAutoAllocationBtn = () => {
    setConfirmDialogOnAutoAllocationShow(true)
  }
  /**
   * 自動配分ダイアログOKボタン押下
   */
  const dialogConfirmOnAutoAllocationBtn = () => {
    if (!Array.isArray(manualYamadumiList)) {
      return
    }

    // 自動配分対象のデータを抽出する
    const autoAllocationList = manualYamadumiList.filter((manualYamadumi) => {
      return (
        manualYamadumi.summaryFlg === 1 && manualYamadumi.autoAllocationFlg === 1
      )
    })
    if (autoAllocationList.length === 0) {
      return
    }

    // 各部位の合計労務数を算出する
    const partList = Array.from(new Set(autoAllocationList.map(item => item.partKbn)))

    const result = partList
      .map(v => {
        const list = autoAllocationList.filter(a => a.partKbn === v)
        return {
          v,
          sum: list.reduce((sum: ManualYamadumiNewItem, r: ManualYamadumiNewItem) => {
            const sumList: DataWorkQuantitySheetItem[] | null = []
            const splitSum = (sum.splitSupplierNumber ?? 0) + (r.splitSupplierNumber ?? 0)
            for (let i = 0; i < 72; i++) {
              if (sum.workQuantity === null || sum.workQuantity[i] === null || r.workQuantity === null || r.workQuantity[i] === null) continue
              const s = (Number(sum.workQuantity[i].value) ?? 0) + (Number(r.workQuantity[i].value) ?? 0)
              sumList.push({
                ...sum.workQuantity[i],
                value: s
              })
            }
            return {
              ...sum,
              splitSupplierNumber: splitSum,
              workQuantity: sumList
            }
          })
        }
      })

    // 最大分割業者数を取得する
    let maxSplitNumber = 0
    result.forEach((manualYamadumi) => {
      if ((manualYamadumi.sum.splitSupplierNumber ?? 0) > maxSplitNumber) {
        maxSplitNumber = manualYamadumi.sum.splitSupplierNumber ?? 0
      }
    })
    if (maxSplitNumber === 0) {
      return
    }
    const notDel = supplierInfo.filter((item) => {
      return item.delFlg !== 1
    })
    if (maxSplitNumber < notDel.length) {
      // M2明細の行数のほうが多い場合は、削除対象外業者数を設定する
      maxSplitNumber = notDel.length
    }

    // 最大分割業者数分の労務数量の空配列を作成する
    const rowLength = autoAllocationList[0]?.workQuantity?.length ?? 0
    const totalArray = Array.from({ length: maxSplitNumber }).map<number[]>(
      () => {
        return Array.from({ length: rowLength }).map<number>(() => {
          return 0
        })
      }
    )

    // 上位業者から順に分配を行う
    result.forEach((partUnit) => {
      // 部位の分割業者数
      const splitNumber = partUnit.sum.splitSupplierNumber
      // 労務数量配列単位に分配を行う
      partUnit.sum.workQuantity?.forEach((item, index) => {
        // 分配を行う
        const averageArray = averageList(splitNumber ?? 0, item.value ?? 0)
        // 最大分割業者数分の労務数量の空配列に分配結果を設定する
        // この時点でM2に表示する合算値になっている
        averageArray.forEach((average, averageIndex) => {
          totalArray[averageIndex][index] += average
        })
      })
    })

    // M2エリアに設定する
    setSupplierInfo(
      produce((draft: SupplierAllocationNewItem[]) => {
        const copy: SupplierAllocationNewItem[] = supplierInfo.map((obj) => Object.assign({}, JSON.parse(JSON.stringify(obj))))
        copy.forEach((draftItem, supIndex) => {
          if (totalArray.length > 0 && draftItem.delFlg !== 1 && draftItem.summaryFlg === 1) {
            draftItem.workQuantity?.forEach((draftValue, index) => {
              let sumAverage = null
              if (totalArray[0][index] !== 0) {
                sumAverage = totalArray[0][index]
              }
              draftValue.value = sumAverage
            })
            // 分割業者数分＞M2業者数の場合に備える
            totalArray.shift()
          }
        })

        // 分割業者数分＞M2業者数の場合、新規行を追加する
        if (totalArray.length > 0) {
          const newRow = _initM2DataSheetList
          totalArray.forEach((totalList, index) => {
            const workQuantity = totalList.map<{
              value: number | null
              readOnly: boolean
            }>((total) => {
              return {
                value: total === 0 ? null : total,
                readOnly: false
              }
            })
            copy.push({
              ...newRow,
              displayOrder: supplierInfo.length + index + 1,
              workQuantity
            })
          })
        }
        draft.splice(0)
        copy.forEach((item) => {
          draft.push(item)
        })
      })
    )

    setConfirmDialogOnAutoAllocationShow(false)
  }
  /**
   * ボタンを含む画面項目の制御について
   */
  const checkBtnDisabledOrDisplay = useCallback(
    (workYamadumi: SimulationCalculationInfoResItem, buildingInfo: SimulationBuildingBuildingInfo, supplierInfo: AllocationSupplier[], manualYamadumi: ManualYamadumiItem[]) => {
      // 費目エリアの計算を行う
      const result = creatWholeResult(
        workYamadumi.autoCalculationMethod ?? '',
        buildingInfo.schedule ?? 0,
        buildingInfo.totalFloorAreaM2 ?? 0,
        buildingInfo.totalFloorAreaTsubo ?? 0,
        workYamadumi,
        buildingInfo.opportunityProgressKbn !== '1'
      )
      // 変更前のステートを保持する
      const inputData: SimulationCalculationInfoResItem = Object.assign({}, JSON.parse(JSON.stringify(workYamadumi)))

      // 適正工期
      if (workYamadumi.yamadumiAutoKbn === '2') {
        if (workYamadumi.autoCalculationMethod === 'A') {
          // 施工数量-基礎
          inputData.constructionQuantityFoundation = workYamadumi.constructionQuantityFoundation
          // 施工数量-地下
          inputData.constructionQuantityUnderground = workYamadumi.constructionQuantityUnderground
          // 施工数量-地上
          inputData.constructionQuantityGround = workYamadumi.constructionQuantityGround
          // 施工数量-全体
          inputData.constructionQuantityAll =
            (inputData.constructionQuantityFoundation ?? 0) +
            (inputData.constructionQuantityUnderground ?? 0) +
            (inputData.constructionQuantityGround ?? 0)

          // 予定労務数-基礎
          inputData.scheduledWorkFoundation =
            Number(workYamadumi.productionRateFoundation) === 0 || Number(workYamadumi.scheduleFoundation) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityFoundation) /
                Number(workYamadumi.productionRateFoundation) /
                Number(workYamadumi.scheduleFoundation) /
                Number(workYamadumi.monthWorkday)
              )
          // 予定労務数-地下
          inputData.scheduledWorkUnderground =
            Number(workYamadumi.productionRateUnderground) === 0 || Number(workYamadumi.scheduleUnderground) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityUnderground) /
                Number(workYamadumi.productionRateUnderground) /
                Number(workYamadumi.scheduleUnderground) /
                Number(workYamadumi.monthWorkday)
              )
          // 予定労務数-地上
          inputData.scheduledWorkGround =
            Number(workYamadumi.productionRateGround) === 0 || Number(workYamadumi.scheduleGround) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityGround) /
                Number(workYamadumi.productionRateGround) /
                Number(workYamadumi.scheduleGround) /
                Number(workYamadumi.monthWorkday)
              )
        } else if (workYamadumi.autoCalculationMethod === 'B') {
          // 施工数量-準備
          inputData.constructionQuantityPreparation = workYamadumi.constructionQuantityPreparation
          // 施工数量-基礎・地下
          inputData.constructionQuantityUnderground = workYamadumi.constructionQuantityUnderground
          // 施工数量-地上
          inputData.constructionQuantityGround = workYamadumi.constructionQuantityGround
          // 施工数量-仕上げ
          inputData.constructionQuantityFinish = workYamadumi.constructionQuantityFinish
          // 施工数量-全体
          inputData.constructionQuantityAll =
            (inputData.constructionQuantityPreparation ?? 0) +
            (inputData.constructionQuantityUnderground ?? 0) +
            (inputData.constructionQuantityGround ?? 0) +
            (inputData.constructionQuantityFinish ?? 0)

          // 予定労務数-準備
          inputData.scheduledWorkPreparation =
            Number(workYamadumi.schedulePreparation) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityPreparation) /
                Number(workYamadumi.schedulePreparation) /
                Number(workYamadumi.monthWorkday)
              )
          // 予定労務数-基礎・地下
          inputData.scheduledWorkUnderground =
            Number(workYamadumi.scheduleUnderground) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityUnderground) /
                Number(workYamadumi.scheduleUnderground) /
                Number(workYamadumi.monthWorkday)
              )
          // 予定労務数-地上
          inputData.scheduledWorkGround =
            Number(workYamadumi.scheduleGround) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityGround) /
                Number(workYamadumi.scheduleGround) /
                Number(workYamadumi.monthWorkday)
              )
          // 予定労務数-仕上げ
          inputData.scheduledWorkFinish =
            Number(workYamadumi.scheduleFinish) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityFinish) /
                Number(workYamadumi.scheduleFinish) /
                Number(workYamadumi.monthWorkday)
              )
        } else if (workYamadumi.autoCalculationMethod === 'C' || workYamadumi.autoCalculationMethod === 'D' || workYamadumi.autoCalculationMethod === 'E') {
          // 施工数量-その他
          inputData.constructionQuantityOther = workYamadumi.constructionQuantityOther
          // 施工数量-仕上げ
          inputData.constructionQuantityFinish = workYamadumi.constructionQuantityFinish
          // 施工数量-全体
          inputData.constructionQuantityAll =
            (inputData.constructionQuantityOther ?? 0) +
            (inputData.constructionQuantityFinish ?? 0)

          // 予定労務数-その他
          inputData.scheduledWorkOther =
            Number(workYamadumi.scheduleOther) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityOther) /
                Number(workYamadumi.scheduleOther) /
                Number(workYamadumi.monthWorkday)
              )
          // 予定労務数-仕上げ
          inputData.scheduledWorkFinish =
            Number(workYamadumi.scheduleFinish) === 0 || Number(workYamadumi.monthWorkday) === 0
              ? 0
              : exactNumberRound(
                Number(inputData.constructionQuantityFinish) /
                Number(workYamadumi.scheduleFinish) /
                Number(workYamadumi.monthWorkday)
              )
        }
      } else {
        // 適正工期以外の場合は自動計算
        if (workYamadumi.autoCalculationMethod === 'A') {
          // 施工数量-全体
          inputData.constructionQuantityAll = result?.wholeResultA === Infinity ||
                                          result?.wholeResultA === undefined ||
                                          isNaN(Number(result?.wholeResultA))
            ? null
            : result?.wholeResultA
          // 施工数量-基礎
          inputData.constructionQuantityFoundation = buildingInfo.opportunityProgressKbn !== '1'
            ? inputData.constructionQuantityFoundation
            : result?.constructionQuantityFoundationA === Infinity ||
                                          result?.constructionQuantityFoundationA === undefined ||
                                          isNaN(Number(result?.constructionQuantityFoundationA))
              ? null
              : result?.constructionQuantityFoundationA
          // 施工数量-地下
          inputData.constructionQuantityUnderground = buildingInfo.opportunityProgressKbn !== '1'
            ? inputData.constructionQuantityUnderground
            : result?.constructionQuantityUndergroundA === Infinity ||
                                          result?.constructionQuantityUndergroundA === undefined ||
                                          isNaN(Number(result?.constructionQuantityUndergroundA))
              ? null
              : result?.constructionQuantityUndergroundA
          // 施工数量-地上
          inputData.constructionQuantityGround = buildingInfo.opportunityProgressKbn !== '1'
            ? inputData.constructionQuantityGround
            : result?.constructionQuantityGroundA === Infinity ||
                                          result?.constructionQuantityGroundA === undefined ||
                                          isNaN(Number(result?.constructionQuantityGroundA))
              ? null
              : result?.constructionQuantityGroundA
          // 予定労務数-基礎
          inputData.scheduledWorkFoundation = result?.scheduledWorkFoundationA === Infinity ||
                                          result?.scheduledWorkFoundationA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFoundationA))
            ? null
            : result?.scheduledWorkFoundationA
          // 予定労務数-地下
          inputData.scheduledWorkUnderground = result?.scheduledWorkUndergroundA === Infinity ||
                                          result?.scheduledWorkUndergroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundA))
            ? null
            : result?.scheduledWorkUndergroundA
          // 予定労務数-先行床
          inputData.scheduledWorkFloorPrecedence = result?.scheduledWorkFloorPrecedenceA === Infinity ||
                                          result?.scheduledWorkFloorPrecedenceA === undefined ||
                                          isNaN(Number(result?.scheduledWorkFloorPrecedenceA))
            ? null
            : result?.scheduledWorkFloorPrecedenceA
          // 予定労務数-地上
          inputData.scheduledWorkGround = result?.scheduledWorkGroundA === Infinity ||
                                          result?.scheduledWorkGroundA === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundA))
            ? null
            : result?.scheduledWorkGroundA
        } else if (workYamadumi.autoCalculationMethod === 'B') {
          // 全体予定労務数
          inputData.scheduledWorkAll = result?.wholeResultB === Infinity ||
                                          result?.wholeResultB === undefined ||
                                          isNaN(Number(result?.wholeResultB))
            ? null
            : result?.wholeResultB
          // 予定労務数-準備
          inputData.scheduledWorkPreparation = result?.scheduledWorkPreparationB === Infinity ||
                                          result?.scheduledWorkPreparationB === undefined ||
                                          isNaN(Number(result?.scheduledWorkPreparationB))
            ? null
            : result?.scheduledWorkPreparationB
          // 予定労務数-基礎・地下
          inputData.scheduledWorkFoundationUnderground = result?.scheduledWorkUndergroundB === Infinity ||
                                          result?.scheduledWorkUndergroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkUndergroundB))
            ? null
            : result?.scheduledWorkUndergroundB
          // 予定労務数-地上
          inputData.scheduledWorkGround = result?.scheduledWorkGroundB === Infinity ||
                                          result?.scheduledWorkGroundB === undefined ||
                                          isNaN(Number(result?.scheduledWorkGroundB))
            ? null
            : result?.scheduledWorkGroundB
          // 予定労務数-仕上げ
          inputData.scheduledWorkFinish = result?.scheduledWorkFinishB === Infinity ||
                                          result?.scheduledWorkFinishB === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishB))
            ? null
            : result?.scheduledWorkFinishB
        } else if (workYamadumi.autoCalculationMethod === 'C') {
          // 全体予定労務数
          inputData.scheduledWorkAll = result?.wholeResultC === Infinity ||
                                          result?.wholeResultC === undefined ||
                                          isNaN(Number(result?.wholeResultC))
            ? null
            : result?.wholeResultC
          // 予定労務数-仕上げ
          inputData.scheduledWorkFinish = buildingInfo.opportunityProgressKbn !== '1'
            ? inputData.scheduledWorkFinish
            : result?.scheduledWorkFinishC === Infinity ||
                                          result?.scheduledWorkFinishC === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishC))
              ? null
              : result?.scheduledWorkFinishC
          // 予定労務数-その他
          inputData.scheduledWorkOther = buildingInfo.opportunityProgressKbn !== '1'
            ? inputData.scheduledWorkOther
            : result?.scheduledWorkOtherC === Infinity ||
                                          result?.scheduledWorkOtherC === undefined ||
                                          isNaN(Number(result?.scheduledWorkOtherC))
              ? null
              : result?.scheduledWorkOtherC
        } else if (workYamadumi.autoCalculationMethod === 'D') {
          // 全体予定労務数
          inputData.scheduledWorkAll = result?.wholeResultD === Infinity ||
                                          result?.wholeResultD === undefined ||
                                          isNaN(Number(result?.wholeResultD))
            ? null
            : result?.wholeResultD
          // 予定労務数-仕上げ
          inputData.scheduledWorkFinish = buildingInfo.opportunityProgressKbn !== '1'
            ? inputData.scheduledWorkFinish
            : result?.scheduledWorkFinishD === Infinity ||
                                          result?.scheduledWorkFinishD === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishD))
              ? null
              : result?.scheduledWorkFinishD
        } else if (workYamadumi.autoCalculationMethod === 'E') {
          // 全体予定労務数
          inputData.scheduledWorkAll = result?.wholeResultE === Infinity ||
                                          result?.wholeResultE === undefined ||
                                          isNaN(Number(result?.wholeResultE))
            ? null
            : result?.wholeResultE
          // 予定労務数-仕上げ
          inputData.scheduledWorkFinish = buildingInfo.opportunityProgressKbn !== '1'
            ? inputData.scheduledWorkFinish
            : result?.scheduledWorkFinishE === Infinity ||
                                          result?.scheduledWorkFinishE === undefined ||
                                          isNaN(Number(result?.scheduledWorkFinishE))
              ? null
              : result?.scheduledWorkFinishE
        }
      }

      // ステートを初期設定する
      setBuildingInfo(buildingInfo)
      setWorkYamadumi(inputData)
      setBeforeWorkYamadumi(inputData)
      const tempManualYamadumiList = getManualYamadumiList(manualYamadumi, inputData, buildingInfo)
      setManualYamadumiList(tempManualYamadumiList)
      setBeforeManualYamadumiList(tempManualYamadumiList)
      const supplierInfoList = getAllocationSupplierList(supplierInfo, inputData, buildingInfo)
      setBeforeSupplierInfo(supplierInfoList)
      setSupplierInfo(supplierInfoList)

      // 業者ヒアリング実施済の業者を抽出する
      const hearingSup = supplierInfo.filter((item) => {
        return item.replyReqFlg === 1
      })

      // 各ボタンを初期化する
      // 確定ボタン
      setIsBottomConfirmDisabled(
        produce((draft) => {
          draft.display = true
          draft.disable = false
        })
      )
      // 一時保存ボタン
      setIsBottomTemporaryPreservationDisabled(
        produce((draft) => {
          draft.display = true
          draft.disable = false
        })
      )
      // 手積クリアボタン
      setIsBottomHandProductClearDisabled(
        produce((draft) => {
          draft.display = true
          draft.disable = false
        })
      )
      // 自動配分ボタン
      setIsBottomAutomaticAllocationDisabled(
        produce((draft) => {
          draft.display = true
          draft.disable = false
        })
      )
      // 再編集ボタン
      setIsBottomEditAgainDisabled(
        produce((draft) => {
          draft.display = true
          draft.disable = false
        })
      )
      // cell
      setIsReadonlyDisabled(
        produce((draft) => {
          draft.disable = false
        })
      )
      // 費目要否
      setIsToggleDisabled(
        produce((draft) => {
          draft.disable = false
        })
      )
      if (buildingInfo?.yamadumiNotApplicableFlg === 1 ||
        (buildingInfo !== undefined &&
        userProp?.authority === 4 &&
        userProp?.branchCode !== buildingInfo.branchCd)) {
        // 山積対象外物件の場合、または自支店以外の物件の場合
        // 確定ボタン
        setIsBottomConfirmDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 一時保存ボタン
        setIsBottomTemporaryPreservationDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 手積クリアボタン
        setIsBottomHandProductClearDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 自動配分ボタン
        setIsBottomAutomaticAllocationDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 再編集ボタン
        setIsBottomEditAgainDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // cell
        setIsReadonlyDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 費目要否
        setIsToggleDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
      } else if (workYamadumi?.decisionFlg === 1) {
        // 確定済みの場合
        // 一時保存ボタン
        setIsBottomTemporaryPreservationDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 手積クリアボタン
        setIsBottomHandProductClearDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 自動配分ボタン
        setIsBottomAutomaticAllocationDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 確定ボタン
        setIsBottomConfirmDisabled(
          produce((draft) => {
            draft.display = false
          })
        )
        // cell
        setIsReadonlyDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 費目要否
        setIsToggleDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
      } else if (supplierInfo.length !== 0 && hearingSup.length > 0) {
        // 業者ヒアリング実施済み（1業者でも回答依頼済み）の場合
        // 再編集ボタン
        setIsBottomEditAgainDisabled(
          produce((draft) => {
            draft.display = false
          })
        )
      } else if (workYamadumi?.expenseNotApplicableFlg === 0) {
        // 費目要否がOFFの場合
        // 一時保存ボタン
        setIsBottomTemporaryPreservationDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 手積クリアボタン
        setIsBottomHandProductClearDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 自動配分ボタン
        setIsBottomAutomaticAllocationDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
        // 再編集ボタン
        setIsBottomEditAgainDisabled(
          produce((draft) => {
            draft.display = false
          })
        )
        // cell
        setIsReadonlyDisabled(
          produce((draft) => {
            draft.disable = true
          })
        )
      } else if (workYamadumi?.decisionFlg === 0 || workYamadumi?.decisionFlg === null) {
        // 未確定の場合
        // 再編集ボタン
        setIsBottomEditAgainDisabled(
          produce((draft) => {
            draft.display = false
          })
        )
        if (buildingInfo?.opportunityProgressKbn === '1') {
          // 自動山積の場合は、手積クリアボタンを非表示にする
          // 手積クリアボタン
          setIsBottomHandProductClearDisabled(
            produce((draft) => {
              draft.display = false
            })
          )
        }
      }
    },
    [workYamadumi, buildingInfo, supplierInfo, manualYamadumiList]
  )
  /**
   * 費目要否変更時の画面制御
   */
  const handleSwitchValChangeStates = useCallback((value: boolean) => {
    // 手積クリアボタン
    setIsBottomHandProductClearDisabled(
      produce((draft) => {
        draft.disable = value
      })
    )
    // 自動配分ボタン
    setIsBottomAutomaticAllocationDisabled(
      produce((draft) => {
        draft.disable = value
      })
    )
    // 一時保存ボタン
    setIsBottomTemporaryPreservationDisabled(
      produce((draft) => {
        draft.disable = value
      })
    )
    // 再編集ボタン
    setIsBottomEditAgainDisabled(
      produce((draft) => {
        draft.display = false
      })
    )
    // cell
    setIsReadonlyDisabled(
      produce((draft) => {
        draft.disable = value
      })
    )
    // M1カレンダ部
    setManualYamadumiList(
      produce((draft) => {
        const copy: ManualYamadumiNewItem[] = manualYamadumiList.map((obj) => Object.assign({}, JSON.parse(JSON.stringify(obj))))
        copy.forEach((copyDraft) => {
          if (copyDraft.summaryFlg === 1) {
            copyDraft.workQuantity?.forEach((cell) => {
              cell.readOnly = value
            })
          }
        })
        draft.splice(0)
        copy.forEach((item) => {
          draft.push(item)
        })
      })
    )
    // M2カレンダ部
    setSupplierInfo(
      produce((draft) => {
        const copy: SupplierAllocationNewItem[] = supplierInfo.map((obj) => Object.assign({}, JSON.parse(JSON.stringify(obj))))
        copy.forEach((copyDraft) => {
          if (copyDraft.summaryFlg === 1) {
            // 費目要否をoffに変更した場合、削除フラグをONにする
            copyDraft.delFlg = value ? 1 : 0
            copyDraft.workQuantity?.forEach((cell) => {
              cell.readOnly = value
            })
          }
        })
        draft.splice(0)
        copy.forEach((item) => {
          draft.push(item)
        })
      })
    )
  }, [workYamadumi, manualYamadumiList, supplierInfo])
  /**
   * M1エリアのデータをセット
   */
  const getManualYamadumiList = useCallback(
    (manualYamadumiList: ManualYamadumiItem[], workYamadumi: SimulationCalculationInfoResItem, buildingInfo: SimulationBuildingBuildingInfo) => {
      const newManualYamadumiList: ManualYamadumiNewItem[] = []
      let flg = false
      if (buildingInfo?.yamadumiNotApplicableFlg === 1 || (buildingInfo !== undefined && userProp?.authority === 4 && userProp?.branchCode !== buildingInfo.branchCd) || workYamadumi?.decisionFlg === 1 || workYamadumi?.expenseNotApplicableFlg === 0) {
        flg = true
      }

      manualYamadumiList?.forEach((item) => {
        const params: ManualYamadumiNewItem = {
          ...item,
          workQuantity: []
        }
        item.workQuantity?.forEach((el) => {
          params?.workQuantity?.push({
            value: el,
            readOnly: flg || item.summaryFlg === 0,
            summaryFlg: item.summaryFlg ?? 0,
            display: item.display ?? 'block'
          })
        })
        // 分割部位の場合
        if (item.partSeq !== 1 && item.summaryFlg === 1) {
          params.partNm = null
          params.splitSupplierNumber = null
        }

        newManualYamadumiList.push(params)
      })

      return newManualYamadumiList
    },
    [manualYamadumiList]
  )
  /**
   * M2エリアのデータをセット
   */
  const getAllocationSupplierList = useCallback(
    (initAllocationSupplierList: AllocationSupplier[], workYamadumi: SimulationCalculationInfoResItem, buildingInfo: SimulationBuildingBuildingInfo) => {
      const allocationSupplierList = initAllocationSupplierList
      const newCreateAllocationSupplierList: SupplierAllocationNewItem[] = []
      // カレンダ部の制御を実施する
      let flg = false
      if (buildingInfo?.yamadumiNotApplicableFlg === 1 || (buildingInfo !== undefined && userProp?.authority === 4 && userProp?.branchCode !== buildingInfo.branchCd) || workYamadumi?.decisionFlg === 1 || workYamadumi?.expenseNotApplicableFlg === 0) {
        flg = true
      }

      // 合計行を除いてstateSupplierCalender.Length = 0の場合、空行を1行表示する
      if (initAllocationSupplierList.length === 0) {
        const init = _initM2DataSheetList
        const empty: SupplierAllocationNewItem = {
          ..._initM2DataSheetList,
          delFlg: workYamadumi?.expenseNotApplicableFlg === 0 ? 1 : 0,
          workQuantity: []
        }
        init?.workQuantity?.forEach(() => {
          empty?.workQuantity?.push({
            value: null,
            readOnly: flg
          })
        })
        newCreateAllocationSupplierList.push(empty)
      }

      allocationSupplierList?.forEach((item: AllocationSupplier) => {
        let rowFlg = flg
        // 業者決定物件の場合はreadOnlyに変更する
        if (item.supplierDecisionBuildingFlg === 1) {
          rowFlg = true
        }
        const params: SupplierAllocationNewItem = {
          ...item,
          supplierCd: (item.pendingFlg === 1 && (item.supplierNm === null || item.supplierNm === undefined)) ? '' : item.supplierCd, // 未決フラグONで業者名が空の場合は、業者コード(DSから始まるAPIでセットした業者コード)をリセットする
          preChangeSupplier: item.supplierCd,
          preChangeSupplierNm: item.supplierNm,
          supplierBranchCd: (item.pendingFlg === 1 && (item.supplierNm === null || item.supplierNm === undefined)) ? '' : item.supplierBranchCd,
          preChangeSupplierBranchCd: item.supplierBranchCd,
          delFlg: 0,
          display: 'block',
          summaryFlg: 1,
          workQuantity: []
        }
        item?.workQuantity?.forEach((el: number | null) => {
          params?.workQuantity?.push({
            value: el,
            readOnly: rowFlg
          })
        })

        newCreateAllocationSupplierList.push(params)
      })

      return newCreateAllocationSupplierList
    },
    [supplierInfo]
  )

  /**
   * 物件情報取得
   */
  const apiGetSimulationBuilding = useCallback(
    (
      simulationYm: string,
      procurementNo: string,
      subNo: string,
      branchCd: string,
      expense: string,
      expenseSeq: string
    ) => {
      dispatch(CommonActions.setIsLoading(true))
      BuildingItemGateway.getSimulationBuildingItem(
        simulationYm,
        procurementNo,
        subNo,
        branchCd,
        expense,
        expenseSeq
      )
        .then((res) => {
          // 取得した物件情報を持ちまわって、労務山積計算情報を取得する
          apiGetWorkYamadumiCalculationInfoList(simulationYm, procurementNo, subNo, branchCd, expense, expenseSeq, res.data.buildingInfo)
        })
        .catch((e) => {
          dispatch(CommonActions.setIsLoading(false))
          throw e
        })
    },
    []
  )
  /**
   * 労務山積計算情報および山積結果(M1)取得
   */
  const apiGetWorkYamadumiCalculationInfoList = useCallback(
    (
      simulationYm: string,
      procurementNo: string,
      subNo: string,
      branchCd: string,
      expense: string,
      expenseSeq: string,
      buildingInfo: SimulationBuildingBuildingInfo
    ) => {
      WorkYamadumiCalculationInfoGateway.getWorkYamadumiCalculationInfoList(
        simulationYm,
        procurementNo,
        subNo,
        branchCd,
        expense,
        expenseSeq
      )
        .then((res) => {
          // 持ちまわっている物件情報および取得した労務山積計算情報をさらに持ち回り、M1エリアの情報を取得する
          initManualYamadumiList(allocationInfoStore, res.data.workYamadumi, buildingInfo)
        })
        .catch((e) => {
          dispatch(CommonActions.setIsLoading(false))
          throw e
        })
    }, [])
  /**
   * 自動山積結果/手積山積結果
   */
  const initManualYamadumiList = useCallback(
    (allocationInfoStore: GetSimulationSupplierAllocationReq, workYamadumi: SimulationCalculationInfoResItem, buildingInfo: SimulationBuildingBuildingInfo) => {
      const yamadumiListData: ManualYamadumiItem[] = []
      /**
       * 自動山積結果取得
       */
      YamadumiAutoGateway.getYamadumiAutoList(
        allocationInfoStore.simulationYm ?? '',
        allocationInfoStore.procurementNo ?? '',
        allocationInfoStore.subNo ?? '',
        allocationInfoStore.branchCd ?? '',
        allocationInfoStore.expense ?? '',
        allocationInfoStore.expenseSeq ?? '',
        displayStartYear
      )
        .then((res) => {
          if (!res.error) {
            const data: SimulationYamadumiAutoItem[] = res.data.autoYamadumiList
            /**
           * 自動山積結果取得
           */
            data.forEach((item) => {
              const params: ManualYamadumiItem = {
                summaryFlg: 0,
                updDtm: null,
                partKbn: null,
                partGroup: item.partGroup,
                partSeq: null,
                autoAllocationFlg: null,
                displayFlg: 1,
                display: 'block',
                partNm: item.partGroupNm + '（自動）',
                splitSupplierNumber: null,
                startYm: item.startYm,
                scheduleMonths: item.scheduleMonths,
                workQuantity: item.workQuantity
              }
              yamadumiListData.push(params)
            })

            /**
              * 手積山積結果取得
              */
            YamadumiManualGateway.getYamadumiManualList(
              allocationInfoStore.simulationYm ?? '',
              allocationInfoStore.procurementNo ?? '',
              allocationInfoStore.subNo ?? '',
              allocationInfoStore.branchCd ?? '',
              allocationInfoStore.expense ?? '',
              allocationInfoStore.expenseSeq ?? '',
              displayStartYear
            )
              .then((res) => {
                if (!res.error) {
                  const data: ManualYamadumiItem[] = res.data.manualYamadumiList
                  /**
                   *  手積山積結果取得
                   */
                  data.forEach((item) => {
                    const params: ManualYamadumiItem = {
                      summaryFlg: 1,
                      updDtm: item.updDtm,
                      partKbn: item.partKbn,
                      partGroup: item.partGroup,
                      partSeq: item.partSeq,
                      autoAllocationFlg: item.autoAllocationFlg,
                      displayFlg: item.displayFlg,
                      display: item.displayFlg === 1 ? 'block' : 'none',
                      partNm: item.partNm,
                      splitSupplierNumber: item.splitSupplierNumber,
                      startYm: item.startYm,
                      scheduleMonths: item.scheduleMonths,
                      workQuantity: item.workQuantity
                    }
                    yamadumiListData.push(params)
                  })
                } else {
                  const resMessages = res.messages
                  if (Array.isArray(resMessages) && resMessages.length > 0) {
                    const messages = resMessages.map<ErrorMessage>((message: any) => {
                      return {
                        id: message.id,
                        content: message.message
                      }
                    })
                    setErrorMessages(messages)
                  }
                }
              })
              .catch((e) => {
                dispatch(CommonActions.setIsLoading(false))
                throw e
              })
              .finally(() => {
                /**
                  *  合計行を追加する
                  */
                sumBottompManualYamadumiList.forEach((item) => {
                  yamadumiListData.push(item)
                })

                // 持ちまわっている物件情報および労務山積計算情報と取得したM1エリア情報をさらに持ち回り、M2エリアの情報を取得する
                const params: GetSimulationSupplierAllocationReq = {
                  simulationYm: allocationInfoStore.simulationYm,
                  procurementNo: allocationInfoStore.procurementNo,
                  subNo: allocationInfoStore.subNo,
                  branchCd: allocationInfoStore.branchCd,
                  expense: allocationInfoStore.expense,
                  expenseSeq: allocationInfoStore.expenseSeq,
                  displayStartYear
                }
                apiGetSupplierAllocation(params, workYamadumi, buildingInfo, yamadumiListData)
              })
          } else {
            const resMessages = res.messages
            if (Array.isArray(resMessages) && resMessages.length > 0) {
              const messages = resMessages.map<ErrorMessage>((message: any) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              setErrorMessages(messages)
            }
          }
        })
        .catch((e) => {
          dispatch(CommonActions.setIsLoading(false))
          throw e
        })
    },
    []
  )
  /**
   * 業者配分結果取得
   */
  const apiGetSupplierAllocation = useCallback(
    (
      params: GetSimulationSupplierAllocationReq,
      workYamadumi: SimulationCalculationInfoResItem,
      buildingInfo: SimulationBuildingBuildingInfo,
      manualYamadumi: ManualYamadumiItem[]
    ) => {
      GetSupplierAllocationGateway.getSimulationSupplierAllocation(
        params
      )
        .then((res) => {
          // ステートを設定し、ボタンおよび画面項目の制御を実施する
          checkBtnDisabledOrDisplay(workYamadumi, buildingInfo, res.data.allocationSupplierList, manualYamadumi)
        })
        .finally(() => {
          dispatch(CommonActions.setIsLoading(false))
        })
    },
    []
  )
  /**
   * 労務山積計算-登録更新
   */
  const apiPostSimulationYamadumi = (
    putManualSimulationAllotmentReq: PutManualSimulationAllotment
  ) => {
    dispatch(CommonActions.setIsLoading(true))
    SimulationYamadumiGateway.putSimulationYamadumi(
      putManualSimulationAllotmentReq
    )
      .then((res) => {
        if (!res.error) {
          // 確定ボタン押下時は、山積対象物件一覧画面に遷移する
          if (confirmDialogUpdataDataMessage.type === '1') {
            // 確定後の遷移であることを示すためにストア書き換える
            dispatch(
              SimulationBuildingSearchActions.setStatus(true)
            )
            // API側からインフォメーションメッセージが存在する場合
            if (Array.isArray(res.messages) && res.messages.length > 0) {
              const messages = res.messages.map<ErrorMessage>((message) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              dispatch(
                SimulationBuildingSearchActions.setMessageInfo(messages)
              )
            }
            // 1つ前の画面に遷移する
            navigate(-1)
          } else {
            // 登録完了ダイアログを表示する
            setMessages([{
              id: 'I004',
              content: MessageProvider.provide(
                'I004',
                ...[confirmDialogUpdataDataMessage.args[0]]
              )
            }])
            // 再検索を実行する
            setSearchFlg(!searchFlg)
          }
        } else {
          if (Array.isArray(res.messages) && res.messages.length > 0) {
            const errorMessages = res.messages.map<ErrorMessage>((message) => {
              return {
                id: message.id,
                content: message.message
              }
            })
            setErrorMessages(errorMessages)
          }
        }
      })
      .finally(() => {
        dispatch(CommonActions.setIsLoading(false))
      })
  }

  /**
   * スクロール位置を初期化する
   */
  useEffect(() => {
    return () => { dispatch(SimulationBuildingSearchActions.setLocation(0)) }
  }, [])

  useEffect(() => {
    /**
    * APIにより情報を取得する
    */
    apiGetSimulationBuilding(
      allocationInfoStore.simulationYm,
      allocationInfoStore.procurementNo,
      allocationInfoStore.subNo,
      allocationInfoStore.branchCd,
      allocationInfoStore.expense,
      allocationInfoStore.expenseSeq
    )
  }, [allocationInfoStore, searchFlg])

  /**
   * 変更検知を行う
   */
  useEffect(() => {
    if (workYamadumi === undefined || manualYamadumiList === undefined || supplierInfo === undefined) return
    // 費目エリア情報
    const afterExpenseInfo = JSON.stringify(workYamadumi)
    const beforeExpenseInfo = JSON.stringify(beforeWorkYamadumi)
    // M1情報
    const afterM1 = JSON.stringify(manualYamadumiList.filter((x) => x.summaryFlg === 1))
    const beforeM1 = JSON.stringify(beforeManualYamadumiList.filter((x) => x.summaryFlg === 1))
    // M2情報
    const afterM2 = JSON.stringify(supplierInfo)
    const beforeM2 = JSON.stringify(beforeSupplierInfo)

    // 初期状態から変更があった場合、変更検知フラグをtrueにする
    if (afterExpenseInfo !== beforeExpenseInfo || afterM1 !== beforeM1 || afterM2 !== beforeM2) {
      setIsChanged(true)
    }
  }, [workYamadumi, manualYamadumiList, supplierInfo])

  return (
    <>
      <Contents>
        <StackLayout gap={5} orientation="vertical">
          {buildingInfo !== undefined && (
            <BuildingInformationCard
              updStsKbn={buildingInfo.updStsKbn}
              buildingInfo={buildingInfo}
              yamadumiAutoKbn={workYamadumi?.yamadumiAutoKbn}
            />
          )}
          {workYamadumi !== undefined && buildingInfo !== undefined && (
            <ExpenseInformation
              workYamadumi={workYamadumi}
              setWorkYamadumi={setWorkYamadumi}
              switchValChangeStates={handleSwitchValChangeStates}
              isReadonlyDisabled={isReadonlyDisabled.disable}
              isToggleDisabled={isToggleDisabled.disable}
              onChange={handleExpenseAreaChange}
              handleUpdataData={handleUpdataData}
            />
          )}
          <CardActions layout="end" style={{ paddingBottom: '0px' }}>
            <Button onClick={handleAllDisplay} className={'pcy-button-long'}>
              全表示
            </Button>
            <Button onClick={handleNotAllDisplay} className={'pcy-button-long'}>
              非表示
            </Button>
          </CardActions>
          {workYamadumi !== undefined && manualYamadumiList !== undefined && (
            <ManualSimulationSheet
              manualYamadumiList={manualYamadumiList}
              onDisplayCheckboxChange={handleOnDisplayCheckboxChange}
              onAutoAllocationCheckboxChange={handleOnAutoAllocationCheckboxChange}
              onSplitSupplierNumberChange={handleOnSplitSupplierNumberChange}
              handleSplit={handleSplit}
              onChangeYear={handleOnChangeYear}
              onChangeMonth={handleOnChangeMonth}
              onScheduleMonthsNumberChange={handleOnScheduleMonthsNumberChange}
              resultDateList={handleResultDateList}
              onCellsChangedManualSimulationSheet={handleOnCellsChangedManualSimulationSheet}
              workYamadumi={workYamadumi}
              isReadonlyDisabled={isReadonlyDisabled.disable}
              displayStartYear={displayStartYear}
            />
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <h3 style={{ marginBottom: 0 }}>
              <span
                style={{ color: '#d51923', fontWeight: '700', fontSize: '16px' }}
              >
                {simulationMessage.dispatchAllotmentSheet.dispatchAllotmentSheetAnnotationInfo}
              </span>
            </h3>
            <CardActions layout="end" style={{ paddingBottom: '0px' }}>
              <Button
                disabled={isReadonlyDisabled.disable}
                onClick={onAddRowBtnM2Click}
                className={'pcy-button-long'}
                themeColor="primary"
              >
                業者追加
              </Button>
              <Button
                disabled={true}
                onClick={onBulkAddRowBtnM2Click}
                className={'pcy-button-long'}
                themeColor="primary"
              >
                見積業者一括選択
              </Button>
            </CardActions>
          </div>
          {supplierInfo !== undefined && (
            <DispatchAllotmentSheet
              onPendingCheckboxChange={handleOnPendingCheckboxChange}
              onUnpublishedCheckboxChange={handleOnUnpublishedCheckboxChange}
              onRecommendationSupplierCheckboxChange={
                handleonRecommendationSupplierCheckboxChange
              }
              onSupplierDecisionBuildingCheckboxChange={
                handleSupplierDecisionBuildingCheckboxChange
              }
              onEstimationBuildingCheckboxChange={
                handleEstimationBuildingSupplierFlgCheckboxChange
              }
              supplierInfo={supplierInfo}
              onCellsChangedM2={handleonCellsChangedM2}
              onDelCheckboxChange={handleOnDelCheckboxChange}
              onRowSupplierNmChange={handleOnRowSupplierNmChange}
              isReadonlyDisabled={isReadonlyDisabled.disable}
              expense={allocationInfoStore.expense}
              displayStartYear={displayStartYear}
            />
          )}
          <CardActions layout="end">
            <Button onClick={handleGoBack} className={'pcy-button-long'}>
              戻る
            </Button>
            {isBottomHandProductClearDisabled.display && (
              <Button
                disabled={isBottomHandProductClearDisabled.disable}
                onClick={() =>
                  handleUpdataData('4', 'I013', '手積クリア', ['手積クリア'])
                }
                className={'pcy-button-long'}
                themeColor="primary"
              >
                手積クリア
              </Button>
            )}
            {isBottomAutomaticAllocationDisabled.display && (
              <Button
                className={'pcy-button-long'}
                themeColor="primary"
                disabled={isBottomAutomaticAllocationDisabled.disable}
                onClick={handleOnAutoAllocationBtn}
              >
                自動配分
              </Button>
            )}
            {isBottomEditAgainDisabled.display && (
              <Button
                disabled={isBottomEditAgainDisabled.disable}
                onClick={() =>
                  handleUpdataData('3', 'I007', '再編集', ['再編集'])
                }
                className={'pcy-button-long'}
                themeColor="primary"
              >
                再編集
              </Button>
            )}

            {isBottomTemporaryPreservationDisabled.display && (
              <Button
                disabled={isBottomTemporaryPreservationDisabled.disable}
                onClick={() =>
                  handleUpdataData('2', 'I016', '一時保存', ['一時保存', '確定'])
                }
                className={'pcy-button-long'}
                themeColor="primary"
              >
                一時保存
              </Button>
            )}

            {isBottomConfirmDisabled.display && (
              <Button
                onClick={() =>
                  handleUpdataData('1', 'I007', '確定', ['確定'])
                }
                className={'pcy-button-long'}
                themeColor="primary"
                disabled={isBottomConfirmDisabled.disable}
              >
                確定
              </Button>
            )}
          </CardActions>
        </StackLayout>
      </Contents>

      <ConfirmDialog
        title={confirmDialogUpdataDataMessage.title}
        open={confirmDialogUpdataDataShow}
        renderCloseButton
        id={confirmDialogUpdataDataMessage.id}
        args={confirmDialogUpdataDataMessage.args}
        onClickOk={dialogConfirmUpdataDataBtn}
        onClickCancel={() => setConfirmDialogUpdataDataShow(false)}
      />
      <ConfirmDialog
        title={'自動配分'}
        open={confirmDialogOnAutoAllocationShow}
        renderCloseButton
        id={'I012'}
        args={['自動配分']}
        onClickOk={dialogConfirmOnAutoAllocationBtn}
        onClickCancel={() => setConfirmDialogOnAutoAllocationShow(false)}
      />
      <ConfirmDialog
        title={'一時保存'}
        open={confirmDialogGoBackShow}
        id={'I016'}
        args={['一時保存', '確定']}
        renderCancelButton={false}
        onClickOk={dialogConfirmGoBackBtn}
      />
      <ErrorMessages type="notification" messages={messages} />
      <ErrorMessages type="dialog" messages={errorMessages} />
    </>
  )
}
